/*! Ceramind - Single Walled Vessel Slab Cutter Set designer
 *  Theme asset: assets/single-wall-vessel-slab-cutter-designer.js
 *  Pairs with:  sections/single-wall-vessel-slab-cutter-designer-block.liquid
 *
 *  Geometry is a straight port of scripts/slabgeom.py, carried over from
 *  slab-cutter-designer.html unchanged so the three can be diffed by eye.
 *  Nothing downloads. The finished outlines are written into the product
 *  form as hidden line item properties, so they arrive with the order.
 */
(function () {
"use strict";

var VERSION = "single-wall-vessel-slab-cutter-designer 1.16.0";

/* ------------------------------------------------------------------ copy
   Every string a customer reads is in here, so a German or Swedish
   storefront is a second object, not a second file. */
var TEXT = {
  steps: ["Slab Thickness", "Shrinkage", "The Seam", "The Base", "Height & Trim", "Dimensions", "Your Set"],
  back: "Back",
  backTo: "Back to ",
  next: "Next: ",
  ready: "Added to your order",
  notReady: "Will not cut \u2014 change the pot"
};

/* ------------------------------------------------------------------- css
   Every selector is under .cmnd-swv. No bare element selectors, so nothing
   here can reach the rest of the page and the theme's own button and input
   rules do not reach in. */
/* ------------------------------------------------------------- palette
   The only colours in the file. The step figures read the same variables,
   so changing this block changes everything.

   Taken from rib-designer-noshadow.js, matched by role rather than by eye:
     #473728  its ink, its primary button, and anything selected
     #A4886E  RIB_COL - the rib itself, axis ticks, node fills
     #5E4A35  the thrown pot in its preview
     #D2C1B4  its major gridline and its secondary button border
     #C4B2A2  its faded side labels
     #E3E0DF  its minor gridline
     #7E9070  FIRED_COL - the fired state, sage green
   The rib designer carries no red, so --alert is ours. */
var PALETTE = [
  "--paper:  #FFFFFF",   /* the widget's own background            */
  "--panel:  #FFFFFF",   /* panels and figure boxes                */
  "--ink:    #473728",   /* body text                              */
  "--quiet:  #A4886E",   /* labels, captions, secondary text       */
  "--rule:   #D2C1B4",   /* every border and divider               */
  "--cut:    #5E4A35",   /* clay and cutter line work in the figures */
  "--accent: #473728",   /* anything chosen, active or selected    */
  "--dim:    #A4886E",   /* dimension lines and their labels       */
  "--fired:  #7E9070",   /* the pot after the kiln, as the rib tool draws it */
  "--alert:  #96301C",   /* will not cut, trim-away, refusals      */
  "--bed:    #C4B2A2",   /* the table line the pots stand on       */
  "--hover:  #E3E0DF",   /* hover tint on anything selectable      */
  "--onacc:  #FFFFFF"    /* text sitting on the accent colour      */
].map(function (d) { return d.replace(/\s+/g, "") + ";"; }).join("");

var CSS = [
".cmnd-swv{" + PALETTE,
"display:block;background:var(--paper);color:var(--ink);text-align:left;",
"font:400 14px/1.45 ui-sans-serif,'Helvetica Neue',Arial,sans-serif;",
"font-variant-numeric:tabular-nums;-webkit-text-size-adjust:100%;",
"container-type:inline-size;}",
".cmnd-swv *,.cmnd-swv *::before,.cmnd-swv *::after{box-sizing:border-box;}",
".cmnd-swv [hidden]{display:none !important;}",
".cmnd-swv .swv-wrap{max-width:1160px;margin:0 auto;padding:16px 16px 24px;}",
".cmnd-swv .swv-h1{margin:0 0 12px;padding:0;font-size:17px;font-weight:600;letter-spacing:-.01em;",
"line-height:1.3;color:var(--ink);text-transform:none;}",

".cmnd-swv .swv-steps{display:flex;gap:3px;margin:0 0 9px;padding:0;border:0;background:none;}",
".cmnd-swv .swv-stepbtn{flex:1;font:inherit;line-height:0;padding:7px 0;margin:0;border:0;",
"background:transparent;cursor:pointer;border-radius:0;min-height:0;}",
".cmnd-swv .swv-stepbtn span{display:block;height:4px;background:var(--rule);}",
".cmnd-swv .swv-stepbtn.done span{background:var(--dim);}",
".cmnd-swv .swv-stepbtn.on span{background:var(--accent);}",
".cmnd-swv .swv-stepbtn:hover:not(.on) span{background:var(--accent);opacity:.45;}",

".cmnd-swv .swv-panel{background:var(--panel);border:1px solid var(--rule);padding:14px 16px;}",
".cmnd-swv .swv-panel+.swv-panel{margin-top:10px;}",
".cmnd-swv .swv-h2{margin:0 0 4px;padding:0;font-size:15px;font-weight:600;line-height:1.3;",
"color:var(--ink);text-transform:none;letter-spacing:0;}",
".cmnd-swv .swv-sub{margin:0 0 14px;font-size:13px;color:var(--quiet);line-height:1.45;}",

".cmnd-swv .swv-split{display:block;}",
".cmnd-swv .swv-split>div+div{margin-top:14px;}",
".cmnd-swv .swv-dims{display:block;}",
".cmnd-swv .swv-wide{display:block;}",
".cmnd-swv .swv-wide>*+*{margin-top:12px;}",
".cmnd-swv .swv-fig{display:block;width:100%;height:auto;max-height:320px;}",
".cmnd-swv .swv-figbox{border:1px solid var(--rule);padding:10px;background:var(--panel);border-radius:0;}",
".cmnd-swv .swv-figbox.on{border-color:var(--accent);box-shadow:inset 0 0 0 1px var(--accent);}",
".cmnd-swv .swv-h4{display:block;margin:0 0 7px;padding:0;font-size:14px;font-weight:600;line-height:1.3;",
"color:var(--ink);text-transform:none;letter-spacing:0;}",
".cmnd-swv .swv-cap{display:block;margin:7px 0 0;font-size:12.5px;color:var(--quiet);line-height:1.45;",
"max-width:74ch;}",
".cmnd-swv .swv-choose{display:block;width:100%;text-align:left;font:inherit;cursor:pointer;",
"color:var(--ink);min-height:0;letter-spacing:0;text-transform:none;}",

".cmnd-swv .swv-field{margin-bottom:10px;}",
".cmnd-swv .swv-field>span{display:block;font-size:12.5px;margin-bottom:4px;color:var(--quiet);}",
".cmnd-swv .swv-field>span.swv-ask{font-size:13px;margin-bottom:5px;}",
".cmnd-swv input[type=number],.cmnd-swv input[type=text]{width:100%;padding:4px 7px;font:inherit;",
"font-size:13px;font-variant-numeric:tabular-nums;border:1px solid var(--rule);border-radius:0;",
"background:var(--panel);color:var(--ink);text-align:right;height:auto;min-height:0;box-shadow:none;margin:0;}",
".cmnd-swv input[type=text]{text-align:left;}",
".cmnd-swv input[type=number]{-moz-appearance:textfield;appearance:textfield;}",
".cmnd-swv input[type=number]::-webkit-outer-spin-button,",
".cmnd-swv input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none;appearance:none;margin:0;}",
".cmnd-swv input[readonly]{background:var(--hover);color:var(--quiet);border-style:dashed;}",
".cmnd-swv .swv-unit{display:inline-flex;align-items:center;width:84px;margin:0;",
"border:1px solid var(--rule);background:var(--panel);}",
".cmnd-swv .swv-unit input[type=number]{flex:1 1 auto;min-width:0;width:auto;border:0;",
"background:transparent;padding:4px 2px 4px 7px;}",
".cmnd-swv .swv-unit input[type=number]:focus-visible{outline:none;}",
".cmnd-swv .swv-unit i{font-style:normal;font-size:12px;color:var(--quiet);padding:0 7px 0 1px;}",
".cmnd-swv .swv-unit:focus-within{outline:2px solid var(--accent);outline-offset:1px;}",
/* The allowance is the one number with no slider beside it, so it gets a
   pair of steppers instead of asking for the keyboard. */
".cmnd-swv .swv-unit.swv-stepped{width:108px;}",
".cmnd-swv .swv-spin{display:flex;flex-direction:column;align-self:stretch;",
"margin-left:auto;border-left:1px solid var(--rule);}",
".cmnd-swv .swv-spin button{flex:1;display:flex;align-items:center;justify-content:center;",
"width:22px;min-width:22px;padding:0;margin:0;border:0;border-radius:0;min-height:0;",
"background:var(--panel);color:var(--quiet);cursor:pointer;font:inherit;line-height:0;}",
".cmnd-swv .swv-spin button+button{border-top:1px solid var(--rule);}",
".cmnd-swv .swv-spin button:hover:not(:disabled){background:var(--hover);color:var(--ink);}",
".cmnd-swv .swv-spin button:disabled{opacity:.3;cursor:not-allowed;}",
".cmnd-swv .swv-spin button::before{content:\"\";display:block;width:0;height:0;",
"border-left:4px solid transparent;border-right:4px solid transparent;}",
".cmnd-swv .swv-spin .swv-up::before{border-bottom:5px solid currentColor;}",
".cmnd-swv .swv-spin .swv-down::before{border-top:5px solid currentColor;}",
".cmnd-swv .swv-unit.swv-locked{background:var(--hover);border-style:dashed;}",
".cmnd-swv .swv-unit.swv-locked input,.cmnd-swv .swv-unit.swv-locked i{color:var(--quiet);}",
".cmnd-swv .swv-unit.swv-stranded{border-color:var(--alert);}",
".cmnd-swv .swv-unit.swv-stranded input{color:var(--alert);}",
".cmnd-swv .swv-unit.swv-blocked{border-color:var(--alert);background:var(--panel);}",
".cmnd-swv .swv-row .swv-unit{width:100%;}",
".cmnd-swv .swv-row .swv-unit i{font-size:11.5px;padding:0 5px 0 1px;}",
".cmnd-swv .swv-row .swv-unit input[type=number]{padding:4px 1px 4px 6px;}",
".cmnd-swv input:focus-visible,.cmnd-swv button:focus-visible{outline:2px solid var(--accent);outline-offset:1px;}",
".cmnd-swv .swv-slider{-webkit-appearance:auto;appearance:auto;width:100%;margin:0;padding:0;height:14px;",
"accent-color:var(--accent);cursor:pointer;background:transparent;border:0;}",
".cmnd-swv .swv-slider:disabled{opacity:.25;cursor:default;}",

".cmnd-swv .swv-seg{display:flex;border:1px solid var(--rule);}",
".cmnd-swv .swv-seg label{flex:1;font-size:13px;cursor:pointer;display:block;margin:0;padding:0;color:var(--ink);}",
".cmnd-swv .swv-seg label+label{border-left:1px solid var(--rule);}",
".cmnd-swv .swv-seg input{position:absolute;opacity:0;pointer-events:none;width:0;height:0;margin:0;}",
".cmnd-swv .swv-seg span{display:block;text-align:center;padding:5px 4px;background:var(--panel);}",
".cmnd-swv .swv-seg input:checked+span{background:var(--accent);color:var(--onacc);}",

".cmnd-swv .swv-note{margin:12px 0 0;padding-top:10px;border-top:1px solid var(--rule);max-width:74ch;",
"font-size:12.5px;line-height:1.55;color:var(--quiet);}",
".cmnd-swv .swv-note b{font-weight:600;color:var(--ink);}",

".cmnd-swv .swv-inline{display:flex;gap:12px;align-items:center;}",
".cmnd-swv .swv-optrow{display:flex;flex-wrap:wrap;gap:12px 22px;align-items:flex-start;margin-top:14px;}",
".cmnd-swv .swv-optrow .swv-field{margin-bottom:0;}",
".cmnd-swv .swv-optrow .swv-field:first-child{flex:1 1 250px;min-width:210px;}",
".cmnd-swv .swv-optrow .swv-field>span{font-size:13px;margin-bottom:5px;}",
".cmnd-swv .swv-optrow .swv-seg,.cmnd-swv .swv-optrow .swv-unit{min-height:32px;}",
".cmnd-swv .swv-optrow .swv-seg label{display:flex;}",
".cmnd-swv .swv-optrow .swv-seg span{flex:1;display:flex;align-items:center;justify-content:center;}",
".cmnd-swv .swv-inline .swv-slider{flex:1;}",
".cmnd-swv .swv-row{display:grid;grid-template-columns:80px 88px minmax(60px,1fr);gap:8px;",
"align-items:center;margin-bottom:9px;}",
".cmnd-swv .swv-row input[type=number]{font-size:13px;}",
".cmnd-swv input.swv-stranded{border-color:var(--alert);color:var(--alert);}",
".cmnd-swv .swv-pick{display:block;cursor:pointer;margin:0;}",
".cmnd-swv .swv-pick input{position:absolute;opacity:0;pointer-events:none;width:0;height:0;margin:0;}",
".cmnd-swv .swv-pick span{display:block;border:1px solid var(--rule);background:var(--panel);padding:3px 8px;font-size:13px;}",
".cmnd-swv .swv-pick input:checked+span{background:var(--accent);border-color:var(--accent);color:var(--onacc);}",
".cmnd-swv .swv-pick:hover input:not(:checked)+span{background:var(--hover);}",

".cmnd-swv .swv-blocked-msg{margin:0 0 8px;font-size:12.5px;color:var(--alert);}",
".cmnd-swv .swv-toast{margin:0 0 10px;padding:9px 11px;border:1px solid var(--accent);",
"background:var(--panel);color:var(--accent);font-size:12.5px;line-height:1.45;}",
".cmnd-swv input.swv-blocked{border-color:var(--alert);background:var(--panel);}",

".cmnd-swv .swv-stage{display:block;margin-top:12px;}",
".cmnd-swv .swv-stagenote{margin-top:12px;max-width:74ch;}",
".cmnd-swv .swv-bedbox{background:var(--panel);border:1px solid var(--rule);padding:8px 9px;}",
".cmnd-swv .swv-bedbox h3{margin:0 0 6px;padding:0;font-size:12px;font-weight:600;color:var(--quiet);",
"line-height:1.3;text-transform:none;letter-spacing:0;}",
".cmnd-swv .swv-bed{display:block;width:100%;height:auto;max-height:400px;}",

".cmnd-swv .swv-status{margin:0 0 10px;padding:9px 11px;background:var(--panel);border:1px solid var(--alert);",
"color:var(--alert);font-size:12.5px;line-height:1.45;}",
/* Prominent, but nothing that could be mistaken for a control. A solid
   fill with reversed text is a button; a grey fill with centred text is a
   disabled button. Full-width rules above and below with no fill and no
   side borders read as a statement, which is what it is. */
".cmnd-swv .swv-ok{margin:18px 0 2px;padding:13px 4px;text-align:center;background:none;",
"border:0;border-top:1px solid var(--rule);border-bottom:1px solid var(--rule);",
"color:var(--ink);font-size:15px;font-weight:600;line-height:1.4;}",

".cmnd-swv .swv-go{font:inherit;font-size:13px;padding:6px 13px;border:1px solid var(--accent);",
"background:var(--accent);color:var(--onacc);cursor:pointer;border-radius:0;min-height:0;margin:0;",
"letter-spacing:0;text-transform:none;line-height:1.45;}",
".cmnd-swv .swv-go.swv-ghost{background:transparent;color:var(--accent);}",
".cmnd-swv .swv-go[disabled]{opacity:.35;cursor:not-allowed;}",
".cmnd-swv .swv-nav{display:flex;justify-content:space-between;gap:10px;margin:0 0 12px;}",

".cmnd-swv .swv-readout{margin:14px 0 0;display:grid;gap:10px 16px;",
"grid-template-columns:repeat(auto-fit,minmax(124px,1fr));}",
".cmnd-swv .swv-readout>div{min-width:0;}",
".cmnd-swv .swv-readout dt{margin:0;font-size:11.5px;line-height:1.35;color:var(--quiet);}",
".cmnd-swv .swv-readout dd{margin:0;font-size:13.5px;line-height:1.35;color:var(--ink);}",

/* A phone, or a narrow product column. Nothing shrinks here - the small
   print goes UP, because 10 and 11px labels that are merely tight on a
   desktop are unreadable held at arm's length. */
"@container (max-width:560px){.cmnd-swv .swv-wrap{padding:12px 12px 20px;}",
".cmnd-swv .swv-h1{font-size:16px;}",
".cmnd-swv .swv-sub{margin-bottom:10px;}",
".cmnd-swv .swv-panel{padding:11px 12px;}",
".cmnd-swv .swv-pick span{padding:3px 6px;}",
".cmnd-swv .swv-readout{grid-template-columns:repeat(auto-fit,minmax(108px,1fr));}",
".cmnd-swv .swv-stepbtn{padding:9px 0;}",
".cmnd-swv .swv-row{grid-template-columns:70px 94px 1fr;gap:6px;margin-bottom:8px;}",
".cmnd-swv .swv-go{flex:1;text-align:center;}",
/* 16px or iOS zooms the page when the field is focused. The row rule is
   more specific than the blanket one, so it has to be named again here. */
".cmnd-swv input[type=number],.cmnd-swv input[type=text],",
".cmnd-swv .swv-row input[type=number]{font-size:16px;}",
".cmnd-swv .swv-unit{width:106px;}",
/* the height choice and the allowance stay on one line all the way down */
".cmnd-swv .swv-optrow{gap:10px 14px;flex-wrap:nowrap;}",
".cmnd-swv .swv-optrow .swv-field:first-child{flex:1 1 auto;min-width:0;}",
".cmnd-swv .swv-optrow .swv-field:last-child{flex:0 0 auto;}",
".cmnd-swv .swv-optrow .swv-unit{width:112px;}",
".cmnd-swv .swv-optrow .swv-seg,.cmnd-swv .swv-optrow .swv-unit{min-height:36px;}",
".cmnd-swv .swv-spin button{width:26px;min-width:26px;}",
".cmnd-swv .swv-optrow .swv-seg span{padding:5px 2px;}}",
"@container (max-width:400px){.cmnd-swv .swv-row{grid-template-columns:66px 90px 1fr;gap:5px;}",
".cmnd-swv .swv-figbox{padding:8px;}.cmnd-swv .swv-nav{gap:6px;}",
".cmnd-swv .swv-go{padding:8px 10px;}",
".cmnd-swv .swv-optrow{gap:8px 10px;}",
".cmnd-swv .swv-optrow .swv-unit{width:104px;}",
".cmnd-swv .swv-readout{grid-template-columns:repeat(auto-fit,minmax(96px,1fr));gap:9px 12px;}}"
].join("");

function injectCss() {
  if (document.getElementById("cmnd-swv-css")) return;
  var s = document.createElement("style");
  s.id = "cmnd-swv-css";
  s.textContent = CSS;
  document.head.appendChild(s);
}

/* =================================================================== geom
   Port of scripts/slabgeom.py. Bed size and profile width come from the
   block settings, so the fit test follows the printer rather than a
   constant baked in here. */
function makeGeom(cfg) {
  var BED_MM = cfg.bed;
  var PROFILE_MM = cfg.profile;
  var USABLE_MM = BED_MM - 2 * PROFILE_MM;
  var MIN_BASE_MM = cfg.minBase;
  var SEAM_GAP_MM = 2 * PROFILE_MM;
  var CHORD_TOL_MM = 0.02;
  var ANGLE_EPS = 1e-7;

  function SlabError(msg) { var e = new Error(msg); e.slab = true; return e; }
  var isSlabError = function (e) { return e && e.slab === true; };

  var rad = function (d) { return (d * Math.PI) / 180; };
  var deg = function (r) { return (r * 180) / Math.PI; };

  function offsetOf(v) { return (v.thickness / 2) / Math.cos(rad(v.angle)); }
  // How much daylight is left between the two sides of the wall at whichever
  // end is narrower. Once this reaches zero the inner surfaces have crossed
  // and the wall would have to pass through itself - which is what an
  // inturned pot does if it is allowed to close past its own thickness.
  var MIN_OPENING_MM = 1.0;
  function opening(v) {
    return Math.min(v.baseD, v.rimD) - (2 * v.thickness) / Math.cos(rad(v.angle));
  }
  function totalH(v) { return v.baseMode === "outer" ? v.wallH + v.thickness : v.wallH; }
  function slantOf(v) { return v.wallH / Math.cos(rad(v.angle)); }

  function discD(v) {
    var d = v.baseD;
    if (v.baseMode === "inner") d -= (2 * v.thickness) / Math.cos(rad(v.angle));
    return d + 2 * v.allowance;
  }

  function resolve(o) {
    var baseD = o.baseD == null ? null : o.baseD;
    var rimD = o.rimD == null ? null : o.rimD;
    var height = o.height == null ? null : o.height;
    var angle = o.angle == null ? null : o.angle;
    var thickness = o.thickness;
    var heightMode = o.heightMode || "total";
    var baseMode = o.baseMode || "outer";
    var allowance = o.allowance == null ? 2.0 : o.allowance;
    var shrinkage = o.shrinkage || 0.0;
    var firedInput = !!o.firedInput;
    var seam = o.seam || "butt";
    var seamAngle = o.seamAngle == null ? 45 : o.seamAngle;

    if (baseMode !== "outer" && baseMode !== "inner") throw SlabError("base mode must be outer or inner");
    if (heightMode !== "total" && heightMode !== "wall") throw SlabError("height mode must be total or wall");
    if (!(thickness > 0)) throw SlabError("slab thickness must be positive");
    if (!(shrinkage >= 0 && shrinkage < 0.5)) throw SlabError("shrinkage must be between 0 and 50 per cent");

    var given = { base: baseD, rim: rimD, height: height, angle: angle };
    Object.keys(given).forEach(function (k) {
      if (given[k] !== null && !isFinite(given[k]))
        throw SlabError("the " + k + " figure is not a number");
    });
    if (!isFinite(thickness)) throw SlabError("the slab thickness is not a number");
    if (!isFinite(allowance)) throw SlabError("the trim allowance is not a number");
    var missing = Object.keys(given).filter(function (k) { return given[k] === null; });
    if (missing.length !== 1)
      throw SlabError("give exactly three of base, rim, height, angle - " + (4 - missing.length) + " were supplied");
    var unknown = missing[0];

    if (firedInput && shrinkage) {
      var k = 1.0 / (1.0 - shrinkage);
      if (baseD !== null) baseD *= k;
      if (rimD !== null) rimD *= k;
      if (height !== null) height *= k;
    }

    var wallH = null;
    if (height !== null) {
      wallH = height;
      if (heightMode === "total" && baseMode === "outer") wallH = height - thickness;
      if (wallH <= 0)
        throw SlabError("a total height of " + height.toFixed(1) + "mm leaves no wall once the " +
          thickness.toFixed(1) + "mm base is subtracted");
    }

    if (unknown === "angle") {
      angle = deg(Math.atan2((rimD - baseD) / 2.0, wallH));
    } else if (unknown === "height") {
      if (Math.abs(angle) < ANGLE_EPS) {
        if (Math.abs(rimD - baseD) > 1e-6)
          throw SlabError("a 0 degree wall cannot change diameter - base and rim must match, or give an angle");
        throw SlabError("height cannot be derived from a 0 degree wall");
      }
      wallH = (rimD - baseD) / (2 * Math.tan(rad(angle)));
      if (wallH <= 0)
        throw SlabError("that base, rim and angle combination gives a negative height - check the sign of the angle");
    } else if (unknown === "rim") {
      rimD = baseD + 2 * wallH * Math.tan(rad(angle));
    } else {
      baseD = rimD - 2 * wallH * Math.tan(rad(angle));
    }

    var v = { baseD: baseD, rimD: rimD, wallH: wallH, angle: angle, thickness: thickness,
              baseMode: baseMode, allowance: allowance, derived: unknown,
              shrinkage: shrinkage, seam: seam, seamAngle: seamAngle };

    if (v.baseD < MIN_BASE_MM)
      throw SlabError("base diameter works out at " + v.baseD.toFixed(1) + "mm, under the " +
        MIN_BASE_MM.toFixed(0) + "mm minimum - shorten the pot or ease the angle");
    if (v.rimD <= 0) throw SlabError("rim diameter works out at " + v.rimD.toFixed(1) + "mm");
    if (v.baseD / 2 - offsetOf(v) <= 0.5)
      throw SlabError("a " + thickness.toFixed(1) + "mm slab is too thick for a " + v.baseD.toFixed(1) +
        "mm base - the wall has no centreline left to roll around");
    if (opening(v) <= MIN_OPENING_MM) {
      var narrow = v.rimD <= v.baseD ? "rim" : "foot";
      throw SlabError("a " + thickness.toFixed(1) + "mm wall closes the " + narrow + " completely at " +
        Math.min(v.baseD, v.rimD).toFixed(1) + "mm - the two sides of the wall would meet, and pass " +
        "through each other");
    }
    return v;
  }

  function arc(R, a0, a1, tol) {
    var span = Math.abs(a1 - a0);
    if (R <= tol) return [[R * Math.sin(a0), R * Math.cos(a0)]];
    var step = 2 * Math.acos(Math.max(-1.0, 1.0 - tol / R));
    var n = Math.max(2, Math.ceil(span / step) + 1);
    var out = [];
    for (var i = 0; i < n; i++) {
      var t = a0 + ((a1 - a0) * i) / (n - 1);
      out.push([R * Math.sin(t), R * Math.cos(t)]);
    }
    return out;
  }

  function develop(v, tol) {
    tol = tol || CHORD_TOL_MM;
    var a = Math.abs(rad(v.angle));
    var off = offsetOf(v);
    var rBaseC = v.baseD / 2 - off;
    var rRimC = v.rimD / 2 - off;
    // Bevelling back from a square end retreats the centreline by half the
    // cut's run, and the run is t / tan(bevel). Two ends, so the piece must be
    // longer by t / tan(bevel) overall. Not an angle change: the loss is a
    // constant length at every radius, so each straight edge is pushed out by
    // half of it, measured square to itself, and no longer points at the apex.
    var d = v.seam === "scarf" ? v.thickness / (2 * Math.tan(rad(v.seamAngle || 45))) : 0;

    if (a < ANGLE_EPS) {
      var w = 2 * Math.PI * rBaseC + 2 * d;
      var h = slantOf(v);
      return [[0, 0], [w, 0], [w, h], [0, h]];
    }
    var rIn = Math.min(rBaseC, rRimC);
    var rOut = Math.max(rBaseC, rRimC);
    var R1 = rIn / Math.sin(a);
    var R2 = rOut / Math.sin(a);
    var theta = 2 * Math.PI * Math.sin(a);
    var half = function (R) { return theta / 2 + (d > 0 ? Math.asin(Math.min(1, d / R)) : 0); };
    var hOut = half(R2), hIn = half(R1);
    return arc(R2, -hOut, hOut, tol).concat(arc(R1, hIn, -hIn, tol));
  }

  function disc(v, tol) {
    var pts = arc(discD(v) / 2, 0, 2 * Math.PI, tol || CHORD_TOL_MM);
    pts.pop();
    return pts;
  }

  // The bounding box of a shape is the bounding box of its convex hull, so the
  // rotation search only ever needs the hull. Exact, not an approximation.
  function convexHull(pts) {
    var p = pts.slice().sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });
    if (p.length < 3) return p;
    var cross = function (o, a, b) { return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]); };
    var half = function (src) {
      var out = [];
      for (var i = 0; i < src.length; i++) {
        var q = src[i];
        while (out.length >= 2 && cross(out[out.length - 2], out[out.length - 1], q) <= 0) out.pop();
        out.push(q);
      }
      return out;
    };
    var lower = half(p), upper = half(p.slice().reverse());
    lower.pop(); upper.pop();
    return lower.concat(upper);
  }

  function minSquare(pts, steps) {
    steps = steps || 361;
    pts = convexHull(pts);
    var best = Infinity, bestAng = 0;
    for (var i = 0; i < steps; i++) {
      var ang = ((Math.PI / 2) * i) / (steps - 1);
      var c = Math.cos(ang), s = Math.sin(ang);
      var xn = Infinity, xx = -Infinity, yn = Infinity, yx = -Infinity;
      for (var j = 0; j < pts.length; j++) {
        var u = pts[j][0] * c - pts[j][1] * s, w = pts[j][0] * s + pts[j][1] * c;
        if (u < xn) xn = u; if (u > xx) xx = u;
        if (w < yn) yn = w; if (w > yx) yx = w;
      }
      var m = Math.max(xx - xn, yx - yn);
      if (m < best) { best = m; bestAng = deg(ang); }
    }
    return isFinite(best) ? [best, bestAng] : [Infinity, 0];
  }

  var SAFETY_MM = 1.0;
  function fitsSafe(v) {
    var f = check(v);
    return f.problems.length === 0 &&
           opening(v) >= MIN_OPENING_MM + SAFETY_MM &&
           f.wrapGap >= SAFETY_MM &&
           f.square <= USABLE_MM - SAFETY_MM &&
           f.discD <= USABLE_MM - SAFETY_MM &&
           f.seamGap >= SEAM_GAP_MM + SAFETY_MM;
  }

  function check(v) {
    var pts = develop(v);
    var xs = pts.map(function (p) { return p[0]; }), ys = pts.map(function (p) { return p[1]; });
    var upright = [Math.max.apply(null, xs) - Math.min.apply(null, xs),
                   Math.max.apply(null, ys) - Math.min.apply(null, ys)];
    var ms = minSquare(pts), square = ms[0], rotation = ms[1];

    var a = Math.abs(rad(v.angle));
    // How far round the piece sweeps, and how much room is left between its
    // two ends. A butt seam stops at 2*PI*sin(a), which can never reach a full
    // turn, but bevelling pushes both ends outward - so a thick slab, a
    // shallow bevel and a steep wall together can in principle carry it past
    // one turn, at which point the flat piece overlaps itself and cannot be
    // cut. The closest anything orderable gets is 0.99 of a turn, so this has
    // never fired; it is here so it cannot start to.
    var gap, wrapGap = Infinity;
    if (a < ANGLE_EPS) {
      gap = Infinity;
    } else {
      var rIn = Math.min(v.baseD / 2, v.rimD / 2) - offsetOf(v);
      var R1 = rIn / Math.sin(a);
      gap = 2 * Math.PI * R1 * (1 - Math.sin(a));
      var dOff = v.seam === "scarf" ? v.thickness / (2 * Math.tan(rad(v.seamAngle || 45))) : 0;
      var span = 2 * Math.PI * Math.sin(a) + 2 * Math.asin(Math.min(1, dOff / R1));
      wrapGap = (2 * Math.PI - span) * R1;      // clearance at the foot, in mm
    }

    var problems = [];
    if (square > USABLE_MM)
      problems.push("the wall outline needs a " + square.toFixed(0) + "mm square and only " +
        USABLE_MM.toFixed(0) + "mm can be printed");
    if (discD(v) > USABLE_MM)
      problems.push("the base outline is " + discD(v).toFixed(0) + "mm across and only " +
        USABLE_MM.toFixed(0) + "mm can be printed");
    if (wrapGap <= 0)
      problems.push("the wall piece would wrap more than once round and overlap itself - " +
        "ease the angle, or use a steeper bevel");
    if (gap < SEAM_GAP_MM)
      problems.push("the two seam edges close to " + gap.toFixed(0) + "mm apart at the foot, so the " +
        PROFILE_MM.toFixed(0) + "mm cutter walls collide - " + SEAM_GAP_MM.toFixed(0) + "mm is needed");
    return { upright: upright, square: square, rotation: rotation, discD: discD(v),
             seamGap: gap, wrapGap: wrapGap, problems: problems, ok: problems.length === 0 };
  }

  var SCAN_SPANS = {
    base: [MIN_BASE_MM, USABLE_MM, 1.0],
    rim: [5.0, 320.0, 1.0],
    height: [5.0, 240.0, 1.0],
    angle: [-75.0, 75.0, 0.25]
  };

  function toSvg(pts, stroke) {
    stroke = stroke == null ? 0.1 : stroke;
    var xs = pts.map(function (p) { return p[0]; }), ys = pts.map(function (p) { return p[1]; });
    var x0 = Math.min.apply(null, xs), y0 = Math.min.apply(null, ys);
    var w = Math.max.apply(null, xs) - x0, h = Math.max.apply(null, ys) - y0;
    var d = "M " + pts.map(function (p) {
      return (p[0] - x0).toFixed(4) + "," + (p[1] - y0).toFixed(4);
    }).join(" L ") + " Z";
    return '<?xml version="1.0" encoding="UTF-8"?>\n' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="' + w.toFixed(4) + 'mm" ' +
      'height="' + h.toFixed(4) + 'mm" viewBox="0 0 ' + w.toFixed(4) + " " + h.toFixed(4) + '">\n' +
      '  <path d="' + d + '" fill="none" stroke="#000000" stroke-width="' + stroke + '"/>\n' +
      "</svg>\n";
  }

  function num(x) {
    var s = (Math.round(x * 10) / 10).toFixed(1).split(".");
    return s[1] === "0" ? s[0] : s[0] + "p" + s[1];
  }

  function stem(v, name) {
    name = name || "vessel";
    var a = num(Math.abs(v.angle)) + (v.angle < 0 ? "in" : "");
    return name + "-b" + num(v.baseD) + "-r" + num(v.rimD) + "-h" + num(totalH(v)) +
           "-a" + a + "-t" + num(v.thickness);
  }

  function filenames(v, name) {
    var s = stem(v, name);
    var base = s + "-base-" + v.baseMode;
    if (v.allowance) base += "-a" + num(v.allowance);
    var joint = v.seam === "scarf" ? "scarf" + num(v.seamAngle) : "butt";
    return [s + "-wall-" + joint + ".svg", base + ".svg"];
  }

  return {
    BED_MM: BED_MM, PROFILE_MM: PROFILE_MM, USABLE_MM: USABLE_MM,
    MIN_BASE_MM: MIN_BASE_MM, ANGLE_EPS: ANGLE_EPS, SCAN_SPANS: SCAN_SPANS,
    isSlabError: isSlabError, rad: rad, deg: deg, offsetOf: offsetOf, totalH: totalH,
    slantOf: slantOf, discD: discD, resolve: resolve, develop: develop, disc: disc,
    check: check, fitsSafe: fitsSafe, SAFETY_MM: SAFETY_MM, opening: opening, toSvg: toSvg, stem: stem, filenames: filenames
  };
}

/* ============================================================== cart form
   The widget never submits anything itself. It writes hidden inputs into
   whichever product form is on the page and lets the theme's own Add to
   Cart do the work, so the cart drawer, discounts and analytics all behave
   exactly as they do on any other product. */
var SKIP_FORM = ".quick-add,quick-add-modal,.card,.product-card,[id*='recommend'],[class*='recommend'],[class*='complementary']";

function findForm(root) {
  var own = root.closest ? root.closest('form[action*="/cart/add"]') : null;
  if (own) return own;
  var all = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
  var usable = all.filter(function (f) {
    return f.querySelector('[name="id"]') && !f.closest(SKIP_FORM);
  });
  if (!usable.length) return null;
  if (usable.length === 1) return usable[0];
  // more than one: take the nearest by document position to the widget
  var best = usable[0], bestScore = Infinity;
  usable.forEach(function (f) {
    var pos = root.compareDocumentPosition(f);
    var score = (pos & Node.DOCUMENT_POSITION_PRECEDING) ? 1 : 0;
    if (score < bestScore) { bestScore = score; best = f; }
  });
  return best;
}

function applyProps(form, props) {
  if (!form) return;
  // clear anything we wrote before, so a removed key does not linger
  Array.prototype.slice.call(form.querySelectorAll("input[data-cmnd-swv]")).forEach(function (el) {
    if (!(el.name.replace(/^properties\[|\]$/g, "") in props)) el.remove();
  });
  Object.keys(props).forEach(function (key) {
    var name = "properties[" + key + "]";
    var input = form.querySelector('input[data-cmnd-swv][name="' + name + '"]');
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.setAttribute("data-cmnd-swv", "");
      form.appendChild(input);
    }
    input.value = props[key];
  });
}

/* Themes re-render the product form on variant change, which throws our
   inputs away. Rather than watch for that, write them again in the capture
   phase of submit and of the button click, both of which run before any
   handler the theme has bound. The same pass is the last line of defence
   against an order for a set that cannot be printed: a disabled button can
   be lost to a re-render, a cancelled submit cannot. */
var LIVE = [];
function forThisForm(target) {
  return LIVE.filter(function (w) {
    var form = w.form();
    return form && (!target || form === target || form.contains(target) || target.contains(form));
  });
}
function rewriteAll(target) {
  var hit = null;
  forThisForm(target).forEach(function (w) {
    applyProps(w.form(), w.props());
    if (!hit && w.blocked()) hit = w;
  });
  return hit;
}
function guard(e) {
  var t = e.target;
  if (e.type === "click") {
    t = t && t.closest ? t.closest('[type="submit"],[name="add"]') : null;
    if (!t) return;
    t = t.form || t.closest("form");
    if (!t) return;
  }
  var blocked = rewriteAll(t);
  if (blocked) {
    e.preventDefault();
    e.stopImmediatePropagation();
    blocked.notify();
  }
}
document.addEventListener("submit", guard, true);
document.addEventListener("click", guard, true);

/* Themes do not always keep the Add to Cart inside the form - a sticky bar
   links it back with the form attribute instead. form.elements covers both,
   a descendant search covers only one. */
function submitButton(form) {
  if (!form || !form.elements) return null;
  var named = form.elements.namedItem ? form.elements.namedItem("add") : null;
  if (named && !named.tagName && named.length) named = named[0];
  if (named && named.tagName) return named;
  var list = Array.prototype.slice.call(form.elements);
  for (var i = 0; i < list.length; i++) {
    var el = list[i];
    if (el.tagName === "BUTTON" && (el.type === "submit" || !el.type)) return el;
    if (el.tagName === "INPUT" && el.type === "submit") return el;
  }
  return null;
}

/* ================================================================= widget */
function mount(root) {
  if (root.getAttribute("data-cmnd-swv-ready") === "1") return;
  root.setAttribute("data-cmnd-swv-ready", "1");

  var D = root.dataset;
  var numOr = function (k, d) { var n = parseFloat(D[k]); return isFinite(n) ? n : d; };
  var cfg = {
    bed: numOr("bed", 250),
    profile: numOr("profile", 11),
    minBase: numOr("minBase", 20),
    thick: numOr("thick", 5),
    shrink: numOr("shrink", 12),
    base: numOr("base", 61.1),
    rim: numOr("rim", 80),
    height: numOr("height", 95),
    angle: numOr("angle", 6),
    allow: numOr("allow", 2),
    heading: D.heading || "",
    blockAdd: D.blockAdd !== "false"
  };

  var G = makeGeom(cfg);
  var USABLE_MM = G.USABLE_MM, PROFILE_MM = G.PROFILE_MM;
  var totalH = G.totalH, discD = G.discD, develop = G.develop, disc = G.disc;
  var resolve = G.resolve, check = G.check, toSvg = G.toSvg, filenames = G.filenames;
  var fitsSafe = G.fitsSafe;
  var SCAN_SPANS = G.SCAN_SPANS;

  var uid = "scd" + Math.random().toString(36).slice(2, 8);
  root.className = (root.className + " cmnd-swv").trim();

  /* ------------------------------------------------------------- markup */
  var one = function (x) { return Number(x).toFixed(1); };
  var DIM_SPEC = [["base", "Base \u00d8", cfg.base, "mm"], ["rim", "Rim \u00d8", cfg.rim, "mm"],
                  ["height", "Height", cfg.height, "mm"], ["angle", "Angle", cfg.angle, "\u00b0"]];

  root.innerHTML =
  '<div class="swv-wrap">' +
    (cfg.heading ? '<p class="swv-h1">' + esc(cfg.heading) + '</p>' : '') +
    '<nav class="swv-steps" data-k="steps" aria-label="Progress"></nav>' +
    '<div class="swv-nav">' +
      '<button type="button" class="swv-go swv-ghost" data-k="nav-back">' + esc(TEXT.back) + '</button>' +
      '<button type="button" class="swv-go" data-k="nav-next"></button>' +
    '</div>' +
    '<p class="swv-toast" data-k="toast" hidden></p>' +

    /* 1 */
    '<section class="swv-panel swv-step" data-step-panel="1">' +
      '<p class="swv-h2">How Thick Is Your Slab?</p>' +
      '<p class="swv-sub">This is the slab you will roll out. Every other size is worked out from it.</p>' +
      '<div class="swv-split"><div>' +
        '<div class="swv-field"><span>Thickness</span><div class="swv-inline">' +
          '<span class="swv-unit"><input type="number" data-k="f-thick" step="0.1" min="1" max="15" value="' +
            one(cfg.thick) + '"><i>mm</i></span>' +
          '<input type="range" class="swv-slider" data-k="r-thick" min="2" max="12" step="0.1" value="' + cfg.thick + '">' +
        '</div></div>' +
        '<p class="swv-note" data-k="thick-note"></p>' +
      '</div><div class="swv-figbox">' +
        '<p class="swv-h4">A Slab, From the Side</p>' +
        '<svg class="swv-fig" data-k="fig-thick" viewBox="0 0 300 48" aria-label="Slab thickness"></svg>' +
      '</div></div>' +
    '</section>' +

    /* 2 */
    '<section class="swv-panel swv-step" data-step-panel="2" hidden>' +
      '<p class="swv-h2">How Much Does Your Clay Shrink?</p>' +
      '<p class="swv-sub">Wet to fired, as one figure. Then say which size the numbers you choose refer to.</p>' +
      '<div class="swv-split"><div>' +
        '<div class="swv-field"><span>Shrinkage</span><div class="swv-inline">' +
          '<span class="swv-unit"><input type="number" data-k="f-shrink" step="0.1" min="0" max="30" value="' +
            one(cfg.shrink) + '"><i>%</i></span>' +
          '<input type="range" class="swv-slider" data-k="r-shrink" min="0" max="25" step="0.1" value="' + cfg.shrink + '">' +
        '</div></div>' +
        '<div class="swv-field" style="margin-top:12px"><span class="swv-ask">The sizes I choose are:</span>' +
          '<div class="swv-seg">' +
            '<label><input type="radio" name="' + uid + '-fired" value="wet" checked><span>what I cut</span></label>' +
            '<label><input type="radio" name="' + uid + '-fired" value="fired"><span>the fired pot</span></label>' +
          '</div></div>' +
        '<p class="swv-note" data-k="shrink-note"></p>' +
      '</div><div class="swv-figbox">' +
        '<p class="swv-h4">Wet, and What Comes Out of the Kiln</p>' +
        '<svg class="swv-fig" data-k="fig-shrink" viewBox="0 0 300 114" aria-label="Shrinkage"></svg>' +
      '</div></div>' +
    '</section>' +

    /* 3 */
    '<section class="swv-panel swv-step" data-step-panel="3" hidden>' +
      '<p class="swv-h2">How Will You Join the Seam?</p>' +
      '<p class="swv-sub">Where the two ends of the rolled wall meet. Looking down on the joint.</p>' +
      '<div class="swv-wide">' +
        '<button type="button" class="swv-choose swv-figbox on" data-k="seam-butt">' +
          '<span class="swv-h4">Butt Joint</span>' +
          '<svg class="swv-fig" viewBox="0 0 300 58" aria-label="Butt joint"></svg>' +
          '<span class="swv-cap">Two square ends meet face to face. Bonding area is one slab thickness. Simplest, and the seam line tends to show.</span>' +
        '</button>' +
        '<button type="button" class="swv-choose swv-figbox" data-k="seam-scarf">' +
          '<span class="swv-h4">Bevelled Both Ends</span>' +
          '<svg class="swv-fig" viewBox="0 0 300 58" aria-label="Scarf joint"></svg>' +
          '<span class="swv-cap">Each end cut back with a bevel tool, opposite ways, so the faces slide together. More bonding area and the outside reads as continuous.</span>' +
        '</button>' +
      '</div>' +
      '<div class="swv-field" data-k="bevel-field" style="margin-top:12px">' +
        '<span>Bevel angle &mdash; whichever your cutter gives you</span>' +
        '<div class="swv-seg">' +
          '<label><input type="radio" name="' + uid + '-bevel" value="30"><span>30&deg;</span></label>' +
          '<label><input type="radio" name="' + uid + '-bevel" value="45" checked><span>45&deg;</span></label>' +
          '<label><input type="radio" name="' + uid + '-bevel" value="60"><span>60&deg;</span></label>' +
        '</div></div>' +
      '<p class="swv-note" data-k="seam-note"></p>' +
    '</section>' +

    /* 4 */
    '<section class="swv-panel swv-step" data-step-panel="4" hidden>' +
      '<p class="swv-h2">How Does the Base Go On?</p>' +
      '<p class="swv-sub">A slice through the bottom corner of the pot.</p>' +
      '<div class="swv-wide">' +
        '<button type="button" class="swv-choose swv-figbox on" data-k="base-outer">' +
          '<span class="swv-h4">The Wall Sits on the Base</span>' +
          '<svg class="swv-fig" viewBox="0 0 300 120" aria-label="Wall sits on the base"></svg>' +
          '<span class="swv-cap">The base is cut to the diameter you choose, so its size does not depend on the slab being exactly right. Any overhang pares off once the wall is on. The pot ends up one slab thickness taller.</span>' +
        '</button>' +
        '<button type="button" class="swv-choose swv-figbox" data-k="base-inner">' +
          '<span class="swv-h4">The Base Drops Inside</span>' +
          '<svg class="swv-fig" viewBox="0 0 300 120" aria-label="Base drops inside the wall"></svg>' +
          '<span class="swv-cap">Wall runs to the table and the base sits inside it, so the outside is one unbroken line. The base has to be cut smaller by the slab thickness, so a mis-rolled slab leaves a gap to fill.</span>' +
        '</button>' +
      '</div>' +
      '<p class="swv-note" data-k="base-note"></p>' +
    '</section>' +

    /* 5 - asked only when the wall stands on the base. Skipped otherwise,
       because then the wall is the whole pot and there is no edge to pare */
    '<section class="swv-panel swv-step" data-step-panel="5" hidden>' +
      '<p class="swv-h2">Which Height Do You Mean?</p>' +
      '<p class="swv-sub">The base sits under the wall, so the finished pot is taller than the wall on its own.</p>' +
      '<div class="swv-figbox">' +
        '<p class="swv-h4">The Two Heights, and the Edge You Pare Back</p>' +
        '<svg class="swv-fig" data-k="fig-height" aria-label="The two heights and the trim allowance"></svg>' +
      '</div>' +
      '<div class="swv-optrow">' +
        '<div class="swv-field">' +
          '<span class="swv-ask">When I select a height, I mean:</span>' +
          '<div class="swv-seg">' +
            '<label><input type="radio" name="' + uid + '-hmode" value="total" checked><span>the whole pot</span></label>' +
            '<label><input type="radio" name="' + uid + '-hmode" value="wall"><span>just the wall</span></label>' +
          '</div></div>' +
        '<div class="swv-field">' +
          '<span>Trim allowance</span>' +
          '<div class="swv-inline"><span class="swv-unit swv-stepped">' +
            '<input type="number" data-k="f-allow" step="0.5" min="0" max="10" value="' + one(cfg.allow) + '">' +
            '<i>mm</i>' +
            '<span class="swv-spin">' +
              '<button type="button" class="swv-up" data-k="allow-up" aria-label="More trim allowance"></button>' +
              '<button type="button" class="swv-down" data-k="allow-down" aria-label="Less trim allowance"></button>' +
            '</span>' +
          '</span></div>' +
        '</div>' +
      '</div>' +
      '<p class="swv-note" data-k="height-note"></p>' +
    '</section>' +

    /* 6 */
    '<section class="swv-step" data-step-panel="6" hidden><div class="swv-panel">' +
      '<p class="swv-h2">The Pot</p>' +
      '<p class="swv-sub">Tap a dimension and the tool works it out for you. You set the other three.</p>' +
      '<p class="swv-blocked-msg" data-k="blocked-msg" hidden></p>' +
      '<div class="swv-dims">' +
        DIM_SPEC.map(function (d) {
          return '<div class="swv-row">' +
            '<label class="swv-pick"><input type="radio" name="' + uid + '-solve" value="' + d[0] + '"' +
              (d[0] === "base" ? " checked" : "") + '><span>' + d[1] + '</span></label>' +
            '<span class="swv-unit"><input type="number" data-k="f-' + d[0] + '" step="0.1" value="' +
              one(d[2]) + '" aria-label="' + d[1] + '"><i>' + d[3] + '</i></span>' +
            '<input type="range" class="swv-slider" data-k="r-' + d[0] + '" step="0.1" aria-label="' + d[1] + ' slider">' +
          '</div>';
        }).join("") +
      '</div>' +
      '<div class="swv-stage">' +
        '<div class="swv-bedbox"><h3 data-k="section-title">Through the Middle</h3>' +
          '<svg class="swv-bed" data-k="section" viewBox="0 0 150 150" aria-label="Cross-section of the pot"></svg></div>' +
        '<div class="swv-stagenote"><p class="swv-status" data-k="status" hidden></p>' +
          '<p class="swv-sub" data-k="pot-summary" style="margin:0"></p></div>' +
      '</div>' +
    '</div></section>' +

    /* 7 */
    '<section class="swv-step" data-step-panel="7" hidden><div class="swv-panel">' +
      '<p class="swv-h2">Your Cutters</p>' +
      '<p class="swv-sub">The two flat pieces, drawn to the same scale as each other. The arc rolls into the wall; the base closes the bottom.</p>' +
      '<p class="swv-status" data-k="status2" hidden></p>' +
      '<div class="swv-bedbox"><h3>The Finished Pot</h3>' +
        '<svg class="swv-bed" data-k="pot" aria-label="The finished vessel"></svg>' +
      '</div>' +
      '<div class="swv-bedbox" style="margin-top:10px">' +
        '<svg class="swv-bed" data-k="cutters" viewBox="0 0 300 150" aria-label="The two cutter outlines"></svg>' +
      '</div>' +
      '<dl class="swv-readout" data-k="readout"></dl>' +
      '<p class="swv-ok" data-k="ready" hidden></p>' +
    '</div></section>' +
  '</div>';

  /* Nothing in here belongs to the product form. Without this, a widget
     placed inside the form would post its own radio groups, and Enter in a
     number field would fire the form's implicit submit - adding to cart
     halfway through a design. An unmatched form id leaves them ownerless. */
  Array.prototype.slice.call(root.querySelectorAll("input,button,select,textarea"))
    .forEach(function (el) { el.setAttribute("form", "cmnd-swv-detached"); });

  /* --------------------------------------------------------- references */
  var $ = function (k) { return root.querySelector('[data-k="' + k + '"]'); };
  var els = {
    base: $("f-base"), rim: $("f-rim"), height: $("f-height"), angle: $("f-angle"),
    thick: $("f-thick"), shrink: $("f-shrink"), allow: $("f-allow")
  };
  var FIELDS = ["base", "rim", "height", "angle"];
  var current = null;
  var baseMode = "outer";
  var seamMode = "butt";
  var lastGood = {};
  var lastProps = {};

  function readSeg(name) {
    if (name === "bmode") return baseMode;
    var el = root.querySelector('input[name="' + uid + "-" + name + '"]:checked');
    return el ? el.value : "";
  }
  var bevelAngle = function () { return Number(readSeg("bevel")) || 45; };
  // A disc dropped inside the wrap is captured by the wall, so there is no
  // edge left to trim. The allowance only applies when the wall stands on it.
  var trimAllowance = function () {
    return baseMode === "inner" ? 0 : (parseFloat(els.allow.value) || 0);
  };
  function solveFor() {
    var r = root.querySelector('input[name="' + uid + '-solve"]:checked');
    return r ? r.value : "base";
  }

  var fmt = function (x, n) { return Number(x).toFixed(n == null ? 1 : n); };
  // the border and background now live on the wrapper, so state goes there
  var boxOf = function (el) { return (el.closest && el.closest(".swv-unit")) || el; };
  var F = fmt;

  /* ------------------------------------------------------------- section */
  var SEC_W = 150, SEC_H = 150;
  var SEC_PAD = { left: 24, right: 24, top: 15, bottom: 20 };

  function drawSection(v) {
    var svg = $("section");
    var a = v.angle * Math.PI / 180;
    var step = v.thickness / Math.cos(a);
    var rb = v.baseD / 2, rr = v.rimD / 2;
    var onDisc = v.baseMode === "outer";
    var floorToWall = onDisc ? v.thickness : 0;
    var H = totalH(v);
    var halfWide = Math.max(rb, rr);

    var roomW = SEC_W - SEC_PAD.left - SEC_PAD.right;
    var roomH = SEC_H - SEC_PAD.top - SEC_PAD.bottom;
    var k = Math.min(roomW / (halfWide * 2), roomH / H);
    var cx = SEC_PAD.left + roomW / 2;
    var floorY = SEC_PAD.top + (roomH + H * k) / 2;
    var X = function (x) { return cx + x * k; };
    var Y = function (y) { return floorY - y * k; };

    var wall = function (sign) {
      var xb = sign * rb, xr = sign * rr;
      var yb = floorToWall, yr = floorToWall + v.wallH;
      return X(xb) + "," + Y(yb) + " " + X(xr) + "," + Y(yr) + " " +
             X(xr - sign * step) + "," + Y(yr) + " " + X(xb - sign * step) + "," + Y(yb);
    };
    var discHalf = onDisc ? rb : rb - step;
    var discFloor = onDisc ? Math.max(0.5, rb - v.thickness * Math.tan(a)) : discHalf;
    var g = "";

    g += '<line x1="' + (X(-halfWide) - 10) + '" y1="' + Y(0) + '" x2="' + (X(halfWide) + 10) +
         '" y2="' + Y(0) + '" stroke="var(--bed)" stroke-width="0.5"/>';
    g += '<polygon points="' + X(-discFloor) + "," + Y(0) + " " + X(discFloor) + "," + Y(0) + " " +
         X(discHalf) + "," + Y(v.thickness) + " " + X(-discHalf) + "," + Y(v.thickness) +
         '" fill="var(--cut)" fill-opacity="0.32" stroke="var(--cut)" stroke-width="0.6"/>';
    [1, -1].forEach(function (sign) {
      g += '<polygon points="' + wall(sign) + '" fill="var(--cut)" fill-opacity="0.16" stroke="var(--cut)" ' +
           'stroke-width="0.6" stroke-linejoin="round"/>';
    });

    // The fired pot: the whole section scaled about the centre of the foot,
    // because both pots stand on the same table on the same axis. It follows
    // the real outer profile, base step and all, and it goes on top - drawn
    // underneath, the base slab swallowed its bottom edge and the foot read
    // as though it had not shrunk at all.
    if (v.shrinkage) {
      var f = 1 - v.shrinkage;
      var half = onDisc
        ? [[discFloor, 0], [rb, v.thickness], [rr, H]]
        : [[rb, 0], [rr, H]];
      var gh = [];
      half.forEach(function (p) { gh.push([-p[0] * f, p[1] * f]); });
      for (var i = half.length - 1; i >= 0; i--) gh.push([half[i][0] * f, half[i][1] * f]);
      g += '<path d="M ' + gh.map(function (p) { return X(p[0]).toFixed(1) + "," + Y(p[1]).toFixed(1); }).join(" L ") +
           ' Z" fill="var(--fired)" fill-opacity="0.09" stroke="var(--fired)" stroke-width="0.7" ' +
           'stroke-dasharray="2.5 1.8" stroke-linejoin="round"/>';
    }

    var q = 'stroke="var(--dim)" stroke-width="0.4"';
    var label = function (x, y, t, anchor, rot) {
      return '<text x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" text-anchor="' + (anchor || "middle") +
        '" font-size="4.2" fill="var(--dim)" font-family="ui-sans-serif, Arial"' +
        (rot ? ' transform="rotate(' + rot + " " + x.toFixed(1) + " " + y.toFixed(1) + ')"' : "") + ">" + t + "</text>";
    };
    var say = function (mm) {
      return v.shrinkage ? fmt(mm) + "mm (" + fmt(mm * (1 - v.shrinkage)) + "mm fired)" : fmt(mm) + "mm";
    };

    var CAP = 2.4;
    var hSpan = function (x1, x2, y) {
      return '<line x1="' + x1.toFixed(1) + '" y1="' + y.toFixed(1) + '" x2="' + x2.toFixed(1) +
        '" y2="' + y.toFixed(1) + '" ' + q + "/>" +
        [x1, x2].map(function (x) {
          return '<line x1="' + x.toFixed(1) + '" y1="' + (y - CAP).toFixed(1) + '" x2="' + x.toFixed(1) +
                 '" y2="' + (y + CAP).toFixed(1) + '" ' + q + "/>";
        }).join("");
    };
    var vSpan = function (y1, y2, x) {
      return '<line x1="' + x.toFixed(1) + '" y1="' + y1.toFixed(1) + '" x2="' + x.toFixed(1) +
        '" y2="' + y2.toFixed(1) + '" ' + q + "/>" +
        [y1, y2].map(function (y) {
          return '<line x1="' + (x - CAP).toFixed(1) + '" y1="' + y.toFixed(1) + '" x2="' + (x + CAP).toFixed(1) +
                 '" y2="' + y.toFixed(1) + '" ' + q + "/>";
        }).join("");
    };

    var topY = Y(H) - 6;
    g += hSpan(X(-rr), X(rr), topY) + label(cx, topY - 2.5, say(v.rimD));
    var botY = Y(0) + 8;
    g += hSpan(X(-rb), X(rb), botY) + label(cx, botY + 5.5, say(v.baseD));
    var sideX = X(halfWide) + 9;
    g += vSpan(Y(0), Y(H), sideX) + label(sideX + 5, (Y(H) + Y(0)) / 2, say(H), "middle", 90);

    svg.setAttribute("viewBox", "0 0 " + SEC_W + " " + SEC_H);
    svg.innerHTML = g;
    $("section-title").textContent = v.shrinkage ? "Through the Middle \u2014 Dashed Is Fired" : "Through the Middle";
  }

  /* ----------------------------------------------------------- the pot
     A straight-sided vessel is a surface of revolution, so an orthographic
     view of it is exact rather than approximated: every horizontal circle
     projects to an ellipse of the same width and sin(tilt) times the height,
     and the sides stay straight. Turning it would show nothing new, which is
     why there is nothing to drag. */
  var TILT = 21 * Math.PI / 180;

  function drawPot(v) {
    var svg = $("pot");
    var sinT = Math.sin(TILT), cosT = Math.cos(TILT);
    var a = (v.angle * Math.PI) / 180, stepIn = v.thickness / Math.cos(a);
    var rb = v.baseD / 2, rr = v.rimD / 2, H = totalH(v);
    var onDisc = v.baseMode === "outer";
    var foot = onDisc ? Math.max(0.5, rb - v.thickness * Math.tan(a)) : rb;
    // foot to rim, in millimetres: the same outer profile the section draws
    var prof = onDisc ? [[foot, 0], [rb, v.thickness], [rr, H]] : [[rb, 0], [rr, H]];
    var shadow = foot * 1.15;
    var xMax = Math.max(foot, rb, rr, shadow);
    var topY = -(H * cosT) - rr * sinT;
    var botY = shadow * sinT;

    // Same 300-unit frame as the cutter outlines below, and the same
    // millimetres, so the two sit at true relative scale: the flat pieces
    // really are far bigger than the pot they roll into. Framing this one to
    // its own drawing instead would make a portrait box as tall as the panel
    // is wide, which the height cap then shrinks back anyway.
    var BOXW = 300, PAD = 6;
    var k = Math.min(1, (BOXW - PAD * 2) / (2 * xMax));
    var BOXH = (botY - topY) * k + PAD * 2;
    var X = function (x) { return BOXW / 2 + x * k; };
    var Y = function (y) { return (y - topY) * k + PAD; };
    var at = function (p) { return [p[0], -p[1] * cosT]; };

    // An ellipse's left and right points are its widest, so the silhouette is
    // the profile mirrored, with no tangent solving needed. Both halves run
    // the same way round it: only the end the pen stops at changes.
    var arc = function (r, cy, toRight) {
      return " A " + (r * k).toFixed(2) + " " + (r * sinT * k).toFixed(2) + " 0 0 1 " +
             X(toRight ? r : -r).toFixed(2) + "," + Y(cy).toFixed(2);
    };
    var side = function (sgn, from, to) {
      var out = "", d = to > from ? 1 : -1;
      for (var i = from; i !== to; i += d) {
        var p = at(prof[i + d]);
        out += " L " + X(sgn * p[0]).toFixed(2) + "," + Y(p[1]).toFixed(2);
      }
      return out;
    };

    var top = at(prof[prof.length - 1]), base = at(prof[0]);
    var body = "M " + X(-base[0]).toFixed(2) + "," + Y(base[1]).toFixed(2) +
               side(-1, 0, prof.length - 1) +
               arc(top[0], top[1], true) +
               side(1, prof.length - 1, 0) +
               arc(base[0], base[1], false) + " Z";

    var rIn = Math.max(0.6, rr - stepIn);
    var ell = function (r, cy) {
      return "M " + X(-r).toFixed(2) + "," + Y(cy).toFixed(2) +
             arc(r, cy, true) + arc(r, cy, false) + " Z";
    };
    var id = uid + "-pot";
    var g =
      '<defs>' +
        '<linearGradient id="' + id + 'b" x1="0" y1="0" x2="1" y2="0">' +
          '<stop offset="0" stop-color="var(--cut)" stop-opacity="0.34"/>' +
          '<stop offset="0.32" stop-color="var(--cut)" stop-opacity="0.08"/>' +
          '<stop offset="0.60" stop-color="var(--cut)" stop-opacity="0.15"/>' +
          '<stop offset="1" stop-color="var(--cut)" stop-opacity="0.38"/>' +
        '</linearGradient>' +
        '<linearGradient id="' + id + 'i" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0" stop-color="var(--cut)" stop-opacity="0.62"/>' +
          '<stop offset="1" stop-color="var(--cut)" stop-opacity="0.34"/>' +
        '</linearGradient>' +
      '</defs>';
    // the table it stands on
    g += '<ellipse cx="' + X(0).toFixed(2) + '" cy="' + Y(base[1]).toFixed(2) + '" rx="' +
         (shadow * k).toFixed(2) + '" ry="' + (shadow * sinT * k).toFixed(2) +
         '" fill="var(--bed)" fill-opacity="0.22"/>';
    // clay is not glass: an opaque backing stops the shadow reading through
    // the wall as though you were looking at the inside of the foot
    g += '<path d="' + body + '" fill="var(--panel)"/>';
    g += '<path d="' + body + '" fill="url(#' + id + 'b)" stroke="var(--cut)" stroke-width="0.7" ' +
         'stroke-linejoin="round"/>';
    // The rim is the nearest surface to the eye, so it has to hide what is
    // under it. On a wide shallow bowl the rim overhangs the foot, and a
    // see-through rim let the foot's outline read straight across the inside.
    g += '<path d="' + ell(top[0], top[1]) + '" fill="var(--panel)"/>';
    g += '<path d="' + ell(top[0], top[1]) + ell(rIn, top[1]) + '" fill-rule="evenodd" ' +
         'fill="var(--cut)" fill-opacity="0.30" stroke="var(--cut)" stroke-width="0.7"/>';
    g += '<path d="' + ell(rIn, top[1]) + '" fill="url(#' + id + 'i)" stroke="var(--cut)" ' +
         'stroke-width="0.5" stroke-opacity="0.7"/>';

    svg.setAttribute("viewBox", "0 0 " + BOXW.toFixed(2) + " " + BOXH.toFixed(2));
    svg.innerHTML = g;
  }

  /* ------------------------------------------------------------- cutters */
  function drawCutters(v) {
    var svg = $("cutters");
    var W = 300, HMAX = 200, pad = 9, gap = 16;
    var wall = develop(v), rD = discD(v);
    var xs = wall.map(function (p) { return p[0]; }), ys = wall.map(function (p) { return p[1]; });
    var minX = Math.min.apply(null, xs), minY = Math.min.apply(null, ys);
    var wW = Math.max.apply(null, xs) - minX, wH = Math.max.apply(null, ys) - minY;
    var totalW = wW + gap + rD, tH = Math.max(wH, rD);
    var k = Math.min((W - pad * 2) / totalW, (HMAX - pad * 2) / tH);
    // the frame is cut to the pieces rather than the pieces floated in a frame
    var H = tH * k + pad * 2;
    var ox = (W - totalW * k) / 2, oy = pad;
    var X = function (x) { return ox + (x - minX) * k; };
    var Y = function (y) { return oy + (y - minY) * k; };

    var g = '<path d="M ' + wall.map(function (p) { return X(p[0]).toFixed(1) + "," + Y(p[1]).toFixed(1); }).join(" L ") +
            ' Z" fill="var(--cut)" fill-opacity="0.14" stroke="var(--cut)" stroke-width="1" stroke-linejoin="round"/>';
    var cx = ox + (wW + gap + rD / 2) * k, cy = oy + (tH / 2) * k;
    g += '<circle cx="' + cx.toFixed(1) + '" cy="' + cy.toFixed(1) + '" r="' + (rD / 2 * k).toFixed(1) +
         '" fill="var(--cut)" fill-opacity="0.14" stroke="var(--cut)" stroke-width="1"/>';

    var cap = function (x, y, t, size) {
      return '<text x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" text-anchor="middle" font-size="' + size +
             '" fill="var(--cut)" font-weight="600" font-family="ui-sans-serif, Arial">' + t + "</text>";
    };
    var pick = function (frac) { return wall[Math.min(wall.length - 1, Math.round(wall.length * frac))]; };
    var mid = pick(0.25), inner = pick(0.75);
    if (mid && inner) g += cap(ox + (wW / 2) * k, (Y(mid[1]) + Y(inner[1])) / 2 + 2.5, "wall", 9);
    g += cap(cx, cy + 3, "base", Math.min(9, rD * k * 0.32));
    svg.setAttribute("viewBox", "0 0 " + W + " " + H.toFixed(1));
    svg.innerHTML = g;
  }

  /* -------------------------------------------------------- slider walls */
  var STEP = { base: 1, rim: 1, height: 1, angle: 0.5 };

  function worksWith(field, x, pinned, opts) {
    var t = {};
    Object.keys(pinned).forEach(function (k) { t[k] = pinned[k]; });
    t[field] = x;
    var o = { baseD: t.base == null ? null : t.base, rimD: t.rim == null ? null : t.rim,
              height: t.height == null ? null : t.height, angle: t.angle == null ? null : t.angle };
    Object.keys(opts).forEach(function (k) { o[k] = opts[k]; });
    try { return fitsSafe(resolve(o)); }
    catch (e) { if (G.isSlabError(e)) return false; throw e; }
  }

  // Walk outward from the current value until it stops working, then bisect.
  // Local, so it costs a few dozen checks rather than a full sweep.
  function localLimits(field, x0, pinned, opts) {
    if (!worksWith(field, x0, pinned, opts)) return null;
    var step = STEP[field];
    var edge = function (dir) {
      var good = x0, tries = 0, coarse = step * 8, next;
      while (tries++ < 120) { next = good + dir * coarse; if (!worksWith(field, next, pinned, opts)) break; good = next; }
      tries = 0;
      while (tries++ < 10) { next = good + dir * step; if (!worksWith(field, next, pinned, opts)) break; good = next; }
      var bad = good + dir * step;
      for (var i = 0; i < 14; i++) {
        var m = (good + bad) / 2;
        if (worksWith(field, m, pinned, opts)) good = m; else bad = m;
      }
      return good;
    };
    return [edge(-1), edge(1)];
  }

  // Where the current value does not work, step outward until something does,
  // so a slider is never left frozen with no way back.
  function nearestWorking(field, x0, pinned, opts) {
    var span = SCAN_SPANS[field], lo = span[0], hi = span[1], coarse = span[2] * 4;
    for (var i = 1; i <= 200; i++) {
      var up = x0 + i * coarse, down = x0 - i * coarse;
      if (up <= hi && worksWith(field, up, pinned, opts)) return up;
      if (down >= lo && worksWith(field, down, pinned, opts)) return down;
      if (up > hi && down < lo) break;
    }
    return null;
  }

  // What a field shows, which is not always what was resolved: fired sizes
  // when those are the ones being chosen, and wall height rather than pot.
  function shownOf(v, key, opts) {
    if (key === "angle") return v.angle;
    var k = opts.firedInput && v.shrinkage ? 1 - v.shrinkage : 1;
    if (key === "base") return v.baseD * k;
    if (key === "rim") return v.rimD * k;
    return (opts.heightMode === "wall" ? v.wallH : totalH(v)) * k;
  }

  // The worked-out dimension has no range of its own - it is whatever the
  // other three make it. Its slider shows how far it could travel if each of
  // those ran to its own limit, so the thumb still means something and still
  // moves as the others are dragged, greyed out though it is.
  function derivedSlider(solve, lims, opts) {
    var slide = $("r-" + solve);
    var now = parseFloat(els[solve].value);
    slide.disabled = true;
    els[solve].removeAttribute("min");
    els[solve].removeAttribute("max");
    if (!isFinite(now)) { els[solve].title = ""; return; }

    var vals = [now];
    FIELDS.forEach(function (field) {
      if (field === solve || !lims[field]) return;
      lims[field].forEach(function (x) {
        var t = {};
        FIELDS.forEach(function (k) { if (k !== solve) t[k] = parseFloat(els[k].value); });
        t[field] = x;
        var o = { baseD: t.base == null ? null : t.base, rimD: t.rim == null ? null : t.rim,
                  height: t.height == null ? null : t.height, angle: t.angle == null ? null : t.angle };
        Object.keys(opts).forEach(function (k) { o[k] = opts[k]; });
        try {
          var vv = resolve(o);
          if (fitsSafe(vv)) vals.push(shownOf(vv, solve, opts));
        } catch (e) { if (!G.isSlabError(e)) throw e; }
      });
    });
    var lo = Math.min.apply(null, vals), hi = Math.max.apply(null, vals);
    if (!(hi > lo)) { lo = now - 1; hi = now + 1; }
    slide.min = (Math.floor(lo * 10) / 10).toFixed(1);
    slide.max = (Math.ceil(hi * 10) / 10).toFixed(1);
    slide.value = now;
    els[solve].title = "Worked out for you \u2014 " + slide.min + " to " + slide.max +
                       (solve === "angle" ? "\u00b0" : "mm") + " as the others move";
  }

  /* ------------------------------------------------- the setup options
     Every option stays available. Choosing one that the current pot cannot
     take does not disable anything and does not raise an error - the option
     is applied and the dimensions give way, each pulled to the nearest end
     of its own range, with a line saying which one moved and where to. */
  function liveOpts() {
    var o = {
      thickness: parseFloat(els.thick.value),
      heightMode: readSeg("hmode"),
      baseMode: baseMode,
      shrinkage: (parseFloat(els.shrink.value) || 0) / 100,
      firedInput: readSeg("fired") === "fired",
      seam: seamMode,
      seamAngle: bevelAngle()
    };
    o.allowance = trimAllowance();
    return o;
  }

  function say(lines) {
    var el = $("toast");
    clearTimeout(sayTimer);
    if (!lines.length) { el.hidden = true; el.textContent = ""; return; }
    el.textContent = lines.join(" ");
    el.hidden = false;
    sayTimer = setTimeout(function () { el.hidden = true; }, 6000);
  }
  var sayTimer = null;

  function refit() {
    if (current && current.fit && current.fit.ok) return;
    var solve = solveFor();
    var opts = liveOpts();
    var moved = [];
    FIELDS.forEach(function (field) {
      if (field === solve) return;
      if (current && current.fit && current.fit.ok) return;
      var now = parseFloat(els[field].value);
      if (!isFinite(now)) return;
      var pinned = {};
      FIELDS.forEach(function (k) { if (k !== field && k !== solve) pinned[k] = parseFloat(els[k].value); });
      if (localLimits(field, now, pinned, opts)) return;      // this one is not the problem
      var near = nearestWorking(field, now, pinned, opts);
      if (near === null) return;
      var lim = localLimits(field, near, pinned, opts);
      if (!lim) return;
      var to = now > lim[1] ? Math.floor(lim[1] * 10) / 10 : Math.ceil(lim[0] * 10) / 10;
      if (Math.abs(to - now) < 0.05) return;
      els[field].value = to.toFixed(1);
      moved.push(NICE[field] + (to < now ? " brought in to " : " taken out to ") +
                 to.toFixed(1) + (field === "angle" ? "\u00b0" : "mm") + ".");
      computeCore();
    });
    if (moved.length) {
      moved.push("Change it back and the pot will not cut at this setting.");
      say(moved);
      syncSetupSliders();
      syncSpin();
      figures();
      syncNav();
    }
  }

  var refitTimer = null;
  function scheduleRefit() {
    clearTimeout(refitTimer);
    refitTimer = setTimeout(refit, 80);
  }

  var clampTimer = null;
  function scheduleClamps(solve, opts) {
    clearTimeout(clampTimer);
    clampTimer = setTimeout(function () {
      var lims = {};
      FIELDS.filter(function (k) { return k !== solve; }).forEach(function (field) {
        var pinned = {};
        FIELDS.forEach(function (k) { if (k !== field && k !== solve) pinned[k] = parseFloat(els[k].value); });
        var lim = localLimits(field, parseFloat(els[field].value), pinned, opts);
        var slide = $("r-" + field);
        var stranded = false;
        if (!lim) {
          var near = nearestWorking(field, parseFloat(els[field].value), pinned, opts);
          if (near !== null) { lim = localLimits(field, near, pinned, opts); stranded = lim !== null; }
        }
        if (lim) {
          els[field].min = (Math.ceil(lim[0] * 10) / 10).toFixed(1);
          els[field].max = (Math.floor(lim[1] * 10) / 10).toFixed(1);
          els[field].title = els[field].min + " to " + els[field].max + (field === "angle" ? "\u00b0" : "mm");
          var now = parseFloat(els[field].value);
          boxOf(els[field]).classList.toggle("swv-stranded", stranded);
          slide.disabled = false;
          slide.min = els[field].min;
          slide.max = els[field].max;
          // set the position last, so new bounds cannot silently clamp it
          slide.value = Math.min(Number(els[field].max), Math.max(Number(els[field].min), now));
          if (now >= Number(els[field].min) - 0.001 && now <= Number(els[field].max) + 0.001) lastGood[field] = now;
        } else {
          els[field].removeAttribute("min");
          els[field].removeAttribute("max");
          els[field].title = "";
          boxOf(els[field]).classList.remove("swv-stranded");
          slide.disabled = true;
        }
        lims[field] = lim;
      });
      derivedSlider(solve, lims, opts);
    }, 120);
  }

  /* ---------------------------------------------------- order properties */
  function buildProps(v, fit, nm) {
    var f = 1 - v.shrinkage;
    var names = filenames(v, nm);
    var p = {};
    p["Cut sizes"] = "Base " + fmt(v.baseD) + " \u00b7 Rim " + fmt(v.rimD) + " \u00b7 Height " +
                     fmt(totalH(v)) + " mm, wall " + fmt(v.angle) + "\u00b0, slab " + fmt(v.thickness) + "mm";
    if (v.shrinkage)
      p["Fired sizes"] = "Base " + fmt(v.baseD * f) + " \u00b7 Rim " + fmt(v.rimD * f) + " \u00b7 Height " +
                         fmt(totalH(v) * f) + " mm at " + fmt(v.shrinkage * 100) + "% shrinkage";
    p["Seam"] = v.seam === "scarf" ? "Bevelled both ends at " + fmt(v.seamAngle, 0) + "\u00b0" : "Butt joint";
    p["Base"] = v.baseMode === "outer"
      ? "Wall sits on the base" + (v.allowance ? ", " + fmt(v.allowance) + "mm trim allowance" : ", cut to size")
      : "Base drops inside the wall";
    // hidden from the customer, present on the order
    p["_wall_file"] = names[0];
    p["_base_file"] = names[1];
    p["_wall_svg"] = toSvg(develop(v));
    p["_base_svg"] = toSvg(disc(v));
    p["_resolved"] = JSON.stringify({
      baseD: round4(v.baseD), rimD: round4(v.rimD), wallH: round4(v.wallH), angle: round4(v.angle),
      thickness: v.thickness, baseMode: v.baseMode, allowance: v.allowance, shrinkage: v.shrinkage,
      seam: v.seam, seamAngle: v.seamAngle, derived: v.derived,
      wallSquare: round4(fit.square), wallRotation: round4(fit.rotation), discD: round4(fit.discD),
      bed: cfg.bed, profile: cfg.profile
    });
    p["_ver"] = VERSION;
    return p;
  }
  function round4(x) { return Math.round(x * 10000) / 10000; }

  function renderReadout(v, fit) {
    var f = 1 - v.shrinkage;
    var rows = [
      ["Base \u00f8", fmt(v.baseD) + "mm"],
      ["Rim \u00f8", fmt(v.rimD) + "mm"],
      ["Height", fmt(totalH(v)) + "mm"],
      ["Wall angle", fmt(v.angle) + "\u00b0"],
      ["Slab", fmt(v.thickness) + "mm"],
      ["Seam", v.seam === "scarf" ? "bevelled " + fmt(v.seamAngle, 0) + "\u00b0" : "butt"],
      ["Base", v.baseMode === "outer" ? "wall sits on it" : "drops inside"]
    ];
    if (v.shrinkage)
      rows.push(["Fired", fmt(v.baseD * f) + " / " + fmt(v.rimD * f) + " / " + fmt(totalH(v) * f) + "mm"]);
    rows.push(["Wall cutter", fmt(fit.upright[0], 0) + " \u00d7 " + fmt(fit.upright[1], 0) + "mm"]);
    rows.push(["Base cutter", fmt(fit.discD, 0) + "mm across"]);
    $("readout").innerHTML = rows.map(function (r) {
      return "<div><dt>" + r[0] + "</dt><dd>" + r[1] + "</dd></div>";
    }).join("");
  }

  function setAddState(ok, why) {
    var form = findForm(root);
    var btn = submitButton(form);
    if (!btn || !cfg.blockAdd) return;
    if (!ok) {
      if (!btn.hasAttribute("data-cmnd-swv-block"))
        btn.setAttribute("data-cmnd-swv-block", btn.disabled ? "was-off" : "ours");
      btn.disabled = true;
      btn.title = why || TEXT.notReady;
    } else {
      if (btn.getAttribute("data-cmnd-swv-block") === "ours") btn.disabled = false;
      btn.removeAttribute("data-cmnd-swv-block");
      btn.title = "";
    }
  }

  /* ------------------------------------------------------------- compute */
  function computeCore() {
    var solve = solveFor();
    FIELDS.forEach(function (k) {
      els[k].readOnly = k === solve;
      els[k].tabIndex = k === solve ? -1 : 0;
      boxOf(els[k]).classList.toggle("swv-locked", k === solve);
    });

    var opts = {
      thickness: parseFloat(els.thick.value),
      heightMode: readSeg("hmode"),
      baseMode: readSeg("bmode"),
      allowance: trimAllowance(),
      shrinkage: (parseFloat(els.shrink.value) || 0) / 100,
      firedInput: readSeg("fired") === "fired",
      seam: seamMode,
      seamAngle: bevelAngle()
    };
    FIELDS.forEach(function (k) {
      if (k === solve) return;
      var key = k === "base" ? "baseD" : k === "rim" ? "rimD" : k;
      opts[key] = parseFloat(els[k].value);
    });

    var out = $("status"), out2 = $("status2");
    var v;
    try {
      v = resolve(opts);
    } catch (e) {
      if (!G.isSlabError(e)) throw e;
      current = null;
      $("section").innerHTML = "";
      $("pot").innerHTML = "";
      $("cutters").innerHTML = "";
      $("readout").innerHTML = "";
      $("pot-summary").textContent = "";
      $("ready").hidden = true;
      var m0 = "That does not describe a pot \u2014 " + e.message + ".";
      out.hidden = false; out.textContent = m0;
      out2.hidden = false; out2.textContent = m0;
      lastProps = {};
      applyProps(findForm(root), {});
      setAddState(false, m0);
      return;
    }

    els[solve].value = fmt(shownOf(v, solve, opts));

    var fit = check(v);
    current = { v: v, fit: fit };

    drawSection(v);
    drawPot(v);
    scheduleClamps(solve, {
      thickness: opts.thickness, heightMode: opts.heightMode, baseMode: opts.baseMode,
      allowance: opts.allowance, shrinkage: opts.shrinkage, firedInput: opts.firedInput,
      seam: opts.seam, seamAngle: opts.seamAngle
    });

    if (!fit.ok) {
      var msg = "This will not cut \u2014 " + fit.problems.join("; ") +
        ". Ease the angle, shorten the pot, or narrow the rim.";
      out.hidden = false; out.textContent = msg;
      out2.hidden = false; out2.textContent = msg;
      $("cutters").innerHTML = "";
      $("readout").innerHTML = "";
      $("pot-summary").textContent = "";
      $("ready").hidden = true;
      lastProps = {};
      applyProps(findForm(root), {});
      setAddState(false, msg);
      return;
    }

    out.hidden = true; out.textContent = "";
    out2.hidden = true; out2.textContent = "";
    drawCutters(v);
    renderReadout(v, fit);
    $("pot-summary").textContent =
      fmt(v.baseD, 0) + "mm foot, " + fmt(v.rimD, 0) + "mm rim, " + fmt(totalH(v), 0) + "mm tall at " +
      fmt(v.angle) + "\u00b0. Wall outline " + fmt(fit.upright[0], 0) + " \u00d7 " + fmt(fit.upright[1], 0) +
      "mm, turned " + fmt(fit.rotation, 0) + "\u00b0 to fit the bed.";

    lastProps = buildProps(v, fit, "vessel");
    applyProps(findForm(root), lastProps);
    setAddState(true);

    var ready = $("ready");
    ready.hidden = false;
    ready.textContent = "Add to Cart to Order This Design";
  }

  /* ------------------------------------------------------ boundary nudge */
  var msgTimer = null;
  var NICE = { base: "Base", rim: "Rim", height: "Height", angle: "Angle" };
  function refuse(field, value, bound, reason) {
    var unit = field === "angle" ? "\u00b0" : "mm";
    var msg = $("blocked-msg");
    msg.textContent = NICE[field] + " stopped at " + fmt(bound) + unit + " \u2014 at " +
      fmt(value) + unit + ", " + reason + ".";
    msg.hidden = false;
    boxOf(els[field]).classList.add("swv-blocked");
    clearTimeout(msgTimer);
    msgTimer = setTimeout(function () {
      msg.hidden = true;
      boxOf(els[field]).classList.remove("swv-blocked");
    }, 3000);
  }

  // Typing is the only way to get a dimension past its limit - the sliders are
  // clamped to it. So hold the edit at the boundary once the value is committed.
  function commit(field) {
    if (els[field].readOnly) return;
    var value = parseFloat(els[field].value);
    if (!isFinite(value)) return;
    var solve = solveFor();
    var pinned = {};
    FIELDS.forEach(function (k) { if (k !== field && k !== solve) pinned[k] = parseFloat(els[k].value); });
    var opts = {
      thickness: parseFloat(els.thick.value),
      heightMode: readSeg("hmode"),
      baseMode: readSeg("bmode"),
      allowance: trimAllowance(),
      shrinkage: (parseFloat(els.shrink.value) || 0) / 100,
      firedInput: readSeg("fired") === "fired",
      seam: seamMode, seamAngle: bevelAngle()
    };
    if (localLimits(field, value, pinned, opts)) return;   // the value works
    var prev = lastGood[field];
    if (prev === undefined) return;
    var lim = localLimits(field, prev, pinned, opts);
    if (!lim) return;
    var bound = value > prev ? lim[1] : lim[0];
    var snapped = value > prev ? Math.floor(bound * 10) / 10 : Math.ceil(bound * 10) / 10;
    var reason = "it will not cut";
    try {
      var t = {};
      Object.keys(pinned).forEach(function (k) { t[k] = pinned[k]; });
      t[field] = value;
      var o = { baseD: t.base == null ? null : t.base, rimD: t.rim == null ? null : t.rim,
                height: t.height == null ? null : t.height, angle: t.angle == null ? null : t.angle };
      Object.keys(opts).forEach(function (k) { o[k] = opts[k]; });
      var f = check(resolve(o));
      if (f.problems.length) reason = f.problems[0];
    } catch (e) {
      if (G.isSlabError(e)) reason = e.message.split(" - ")[0]; else throw e;
    }
    refuse(field, value, snapped, reason);
    els[field].value = snapped.toFixed(1);
    compute();
  }

  /* ------------------------------------------------------- step figures */
  var TXT = function (x, y, t, anchor, size) {
    return '<text x="' + x + '" y="' + y + '" text-anchor="' + (anchor || "middle") + '" font-size="' +
      (size || 9) + '" fill="var(--quiet)" font-family="ui-sans-serif, Arial">' + t + "</text>";
  };

  function figThickness() {
    var t = parseFloat(els.thick.value) || 5;
    var px = Math.max(4, t * 3.2);
    // the box follows the slab rather than holding a fixed frame around it,
    // so a thin slab does not sit in a tall empty rectangle
    var H = Math.max(px, 14) + 14;
    var cyc = H / 2, top = cyc - px / 2, bot = cyc + px / 2, dimX = 50;
    var g = '<rect x="68" y="' + top.toFixed(1) + '" width="196" height="' + px.toFixed(1) +
      '" fill="var(--cut)" fill-opacity="0.18" stroke="var(--cut)" stroke-width="1"/>';
    g += '<line x1="' + dimX + '" y1="' + top.toFixed(1) + '" x2="' + dimX + '" y2="' + bot.toFixed(1) +
      '" stroke="var(--dim)" stroke-width="0.8"/>';
    [top, bot].forEach(function (y) {
      g += '<line x1="' + (dimX - 4) + '" y1="' + y.toFixed(1) + '" x2="' + (dimX + 4) + '" y2="' + y.toFixed(1) +
        '" stroke="var(--dim)" stroke-width="0.8"/>';
    });
    g += '<text x="' + (dimX - 8) + '" y="' + (cyc + 3.5).toFixed(1) +
      '" text-anchor="end" font-size="10" fill="var(--dim)" font-family="ui-sans-serif, Arial">' + F(t) + "mm</text>";
    $("fig-thick").setAttribute("viewBox", "0 0 300 " + H.toFixed(1));
    $("fig-thick").innerHTML = g;
    var lo1 = Math.max(2, t - 1), hi1 = Math.min(12, t + 1);
    var lo2 = Math.max(2, t - 2), hi2 = Math.min(12, t + 2);
    $("thick-note").innerHTML =
      "<b>It does not have to be exact.</b> Roll anywhere between <b>" + F(lo1) + "mm</b> and <b>" +
      F(hi1) + "mm</b> and your pot still comes out within a millimetre of the size you asked for. " +
      "Between <b>" + F(lo2) + "mm</b> and <b>" + F(hi2) + "mm</b>, within two millimetres. " +
      "The shape stays the same either way.";
  }

  function figShrink() {
    var sh = (parseFloat(els.shrink.value) || 0) / 100;
    var k = 1 - sh;
    var pot = function (s, cx) {
      var rb = 26 * s, rr = 34 * s, h = 74 * s, y0 = 92;
      return (cx - rb) + "," + y0 + " " + (cx - rr) + "," + (y0 - h) + " " +
             (cx + rr) + "," + (y0 - h) + " " + (cx + rb) + "," + y0;
    };
    var fired = readSeg("fired") === "fired";
    var live = { fill: "0.18", w: "1.2", op: "1" };
    var dim = { fill: "0.05", w: "0.9", op: "0.55" };
    var A = fired ? dim : live, B = fired ? live : dim;
    A.stroke = "var(--cut)";
    B.stroke = "var(--fired)";
    var g = '<line x1="20" y1="92" x2="280" y2="92" stroke="var(--bed)" stroke-width="0.6"/>';
    g += '<polygon points="' + pot(1, 95) + '" fill="var(--cut)" fill-opacity="' + A.fill + '" stroke="' + A.stroke +
      '" stroke-width="' + A.w + '" opacity="' + A.op + '"/>';
    g += '<polygon points="' + pot(k, 215) + '" fill="var(--fired)" fill-opacity="' + B.fill + '" stroke="' + B.stroke +
      '" stroke-width="' + B.w + '" stroke-dasharray="3 2" opacity="' + B.op + '"/>';
    g += '<text x="95" y="108" text-anchor="middle" font-size="9" font-family="ui-sans-serif, Arial" fill="' +
      (fired ? "var(--quiet)" : "var(--cut)") + '" font-weight="' + (fired ? 400 : 600) + '">wet \u2014 what you cut</text>';
    g += '<text x="215" y="108" text-anchor="middle" font-size="9" font-family="ui-sans-serif, Arial" fill="' +
      (fired ? "var(--cut)" : "var(--quiet)") + '" font-weight="' + (fired ? 600 : 400) + '">fired \u2014 ' +
      F(sh * 100) + "% smaller</text>";
    g += '<path d="M 140 52 L 165 52" stroke="var(--quiet)" stroke-width="0.8"/>';
    g += '<path d="M 165 52 l -5 -3 l 0 6 z" fill="var(--quiet)"/>';
    $("fig-shrink").innerHTML = g;
    $("shrink-note").innerHTML = fired
      ? "You will choose finished sizes. A pot you want <b>100mm</b> across gets cut at <b>" + F(100 / k) +
        "mm</b>, and the cutters are made to the wet figure, because that is what gets cut."
      : "You will choose cutting sizes. Cut something <b>100mm</b> across and it comes out of the kiln at <b>" +
        F(100 * k) + "mm</b>.";
  }

  function figSeam() {
    var t = 22, x0 = 60, x1 = 240, mid = 150, yc = 24;
    var butt =
      '<rect x="' + x0 + '" y="' + (yc - t / 2) + '" width="' + (mid - x0 - 1) + '" height="' + t +
        '" fill="var(--cut)" fill-opacity="0.16" stroke="var(--cut)" stroke-width="1"/>' +
      '<rect x="' + (mid + 1) + '" y="' + (yc - t / 2) + '" width="' + (x1 - mid - 1) + '" height="' + t +
        '" fill="var(--cut)" fill-opacity="0.16" stroke="var(--cut)" stroke-width="1"/>' +
      TXT(mid, 52, "square ends, meeting face to face");
    // One cut through the slab at the bevel angle makes both faces at once, so
    // they slope the same way and slide flat together. Drawn pulled apart.
    var g2 = 9, top = yc - t / 2, bot = yc + t / 2;
    var run = t / Math.tan(bevelAngle() * Math.PI / 180);
    var scarf =
      '<polygon points="' + x0 + "," + top + " " + (mid - g2 + run / 2) + "," + top + " " +
        (mid - g2 - run / 2) + "," + bot + " " + x0 + "," + bot +
        '" fill="var(--cut)" fill-opacity="0.16" stroke="var(--cut)" stroke-width="1"/>' +
      '<polygon points="' + (mid + g2 + run / 2) + "," + top + " " + x1 + "," + top + " " + x1 + "," + bot + " " +
        (mid + g2 - run / 2) + "," + bot +
        '" fill="var(--cut)" fill-opacity="0.16" stroke="var(--cut)" stroke-width="1"/>' +
      '<path d="M ' + (mid - g2 + run / 2 + 2) + "," + (top - 8) + " L " + (mid + g2 + run / 2 - 2) + "," + (top - 8) +
        '" stroke="var(--quiet)" stroke-width="0.8"/>' +
      '<path d="M ' + (mid + g2 + run / 2 - 2) + "," + (top - 8) + ' l -5 -3 l 0 6 z" fill="var(--quiet)"/>' +
      TXT(mid, 52, bevelAngle() + "\u00b0 faces, sliding together");
    $("seam-butt").querySelector("svg").innerHTML = butt;
    $("seam-scarf").querySelector("svg").innerHTML = scarf;
    $("seam-butt").classList.toggle("on", seamMode === "butt");
    $("seam-scarf").classList.toggle("on", seamMode === "scarf");
    $("bevel-field").hidden = seamMode !== "scarf";
    var t2 = parseFloat(els.thick.value) || 5;
    var eaten = t2 / Math.tan(bevelAngle() * Math.PI / 180);
    $("seam-note").innerHTML = seamMode === "scarf"
      ? "Bevelling back from a square end shortens it, so at <b>" + bevelAngle() + "\u00b0</b> on a " + F(t2) +
        "mm slab the joint swallows <b>" + F(eaten) + "mm</b> and the wall piece is cut that much longer. " +
        "Without it the pot would come out <b>" + F(eaten / Math.PI) + "mm</b> narrower than you asked, " +
        "whatever its size."
      : "Square ends take no compensation \u2014 the piece is exactly the rolled length. " +
        "Roughen and slip both faces before joining.";
  }

  // One drawing at two levels of detail. Step 4 shows how the pieces meet and
  // nothing else, because that is the only thing being chosen there. Step 5
  // takes the same drawing and adds the two heights and the edge to pare back.
  function baseDrawing(mode, withDetail) {
    var tMM = parseFloat(els.thick.value) || 5;
    var allow = withDetail ? trimAllowance() : 0;
    var S = 2.2;
    var t = Math.max(6, tMM * S), aw = allow * S;
    var floor = 100, wallH = 68, rb = 58, lean = 12, edge = rb + lean;
    var onDisc = mode === "outer";
    var wallBottom = onDisc ? floor - t : floor;
    var discHalf = onDisc ? rb : rb - t;
    var dimX = 150 - edge - 36;

    var left = withDetail ? dimX - 13 : 150 - edge - 10;
    var right = 150 + edge + (aw > 0.4 ? aw + 6 : 10);
    var top = floor - t - wallH - 6;
    var bot = floor + (aw > 0.4 ? 15 : 7);

    var g = '<line x1="' + (left + 3) + '" y1="' + floor + '" x2="' + (right - 3) + '" y2="' + floor +
            '" stroke="var(--bed)" stroke-width="0.6"/>';
    // Square-cut disc, as it comes off the cutter. Paring it back to the
    // wall's taper happens later, so it belongs in the finished pot, not here.
    g += '<rect x="' + (150 - discHalf) + '" y="' + (floor - t) + '" width="' + (discHalf * 2) + '" height="' + t +
      '" fill="var(--cut)" fill-opacity="0.3" stroke="var(--cut)" stroke-width="0.9"/>';
    if (aw > 0.4 && onDisc) {
      [1, -1].forEach(function (sgn) {
        var x = sgn > 0 ? 150 + rb : 150 - rb - aw;
        g += '<rect x="' + x + '" y="' + (floor - t) + '" width="' + aw + '" height="' + t +
          '" fill="var(--alert)" fill-opacity="0.35" stroke="var(--alert)" stroke-width="0.7" stroke-dasharray="2 1.5"/>';
      });
      g += '<text x="150" y="' + (floor + 12) + '" text-anchor="middle" font-size="8" fill="var(--alert)" ' +
        'font-family="ui-sans-serif, Arial">dashed \u2014 ' + F(allow) + "mm to pare back each side</text>";
    }
    [1, -1].forEach(function (sgn) {
      var xb = 150 + sgn * rb, xt = 150 + sgn * edge;
      g += '<polygon points="' + xb + "," + wallBottom + " " + xt + "," + (wallBottom - wallH) + " " +
        (xt - sgn * t) + "," + (wallBottom - wallH) + " " + (xb - sgn * t) + "," + wallBottom +
        '" fill="var(--cut)" fill-opacity="0.16" stroke="var(--cut)" stroke-width="0.9"/>';
    });

    if (withDetail) {
      var wholeIsLive = readSeg("hmode") === "total";
      var span = function (x, y1, y2, live) {
        var col = live ? "var(--accent)" : "var(--dim)", wdt = live ? 1.1 : 0.6, op = live ? 1 : 0.5;
        return '<line x1="' + x + '" y1="' + y1 + '" x2="' + x + '" y2="' + y2 + '" stroke="' + col +
          '" stroke-width="' + wdt + '" opacity="' + op + '"/>' +
          [y1, y2].map(function (y) {
            return '<line x1="' + (x - 3) + '" y1="' + y + '" x2="' + (x + 3) + '" y2="' + y + '" stroke="' + col +
              '" stroke-width="' + wdt + '" opacity="' + op + '"/>';
          }).join("");
      };
      var rot = function (x, y, label, live) {
        return '<text x="' + x + '" y="' + y + '" text-anchor="middle" font-size="8" fill="' +
          (live ? "var(--accent)" : "var(--dim)") + '" font-weight="' + (live ? 600 : 400) + '" opacity="' +
          (live ? 1 : 0.65) + '" font-family="ui-sans-serif, Arial" transform="rotate(-90 ' + x + " " + y + ')">' +
          label + "</text>";
      };
      var LABEL_OFF = 5, GAP = 18;
      g += span(dimX, floor, wallBottom - wallH, wholeIsLive) +
           rot(dimX - LABEL_OFF, (floor + wallBottom - wallH) / 2, "whole pot", wholeIsLive);
      g += span(dimX + GAP, wallBottom, wallBottom - wallH, !wholeIsLive) +
           rot(dimX + GAP - LABEL_OFF, (wallBottom + wallBottom - wallH) / 2, "wall", !wholeIsLive);
    }
    return { g: g, box: left.toFixed(1) + " " + top.toFixed(1) + " " +
                        (right - left).toFixed(1) + " " + (bot - top).toFixed(1) };
  }

  function figBase() {
    // Both take the same frame: top and bottom depend only on the slab, which
    // is shared, so the two sit level without either carrying dead space.
    ["outer", "inner"].forEach(function (mode) {
      var d = baseDrawing(mode, false);
      var svg = $("base-" + mode).querySelector("svg");
      svg.setAttribute("viewBox", d.box);
      svg.innerHTML = d.g;
    });
    $("base-outer").classList.toggle("on", baseMode === "outer");
    $("base-inner").classList.toggle("on", baseMode === "inner");
    var tMM = parseFloat(els.thick.value) || 5;
    $("base-note").innerHTML = baseMode === "outer"
      ? "The base is cut to the diameter you ask for, so its size does not hang on the slab coming out at " +
        "exactly " + F(tMM) + "mm. In return the pot finishes <b>" + F(tMM) + "mm</b> taller than its wall, " +
        "and the base needs paring back flush once the wall is on. The next step settles both."
      : "The wall runs to the table, so the pot is exactly as tall as the wall and there is no edge to pare " +
        "back. In return the base has to be cut smaller by the slab thickness, so a slab rolled thin or thick " +
        "leaves a gap to fill.";
  }

  function figHeight() {
    var d = baseDrawing("outer", true);
    var svg = $("fig-height");
    svg.setAttribute("viewBox", d.box);
    svg.innerHTML = d.g;
    var tMM = parseFloat(els.thick.value) || 5;
    var allow = trimAllowance();
    $("height-note").innerHTML =
      "The wall stands on a " + F(tMM) + "mm base, so the whole pot finishes <b>" + F(tMM) +
      "mm</b> taller than the wall on its own. The highlighted span is the one your height figure refers to. " +
      (allow
        ? "The base is cut <b>" + F(allow) + "mm</b> wider all round, shown dashed, and you pare that back " +
          "flush once the wall is standing on it."
        : "With no allowance the base is cut to final size, so it has to match the rolled wall exactly.");
  }

  function figures() { figThickness(); figShrink(); figSeam(); figBase(); figHeight(); }

  function syncSetupSliders() {
    $("r-thick").value = els.thick.value;
    $("r-shrink").value = els.shrink.value;
  }
  function compute() { computeCore(); syncSetupSliders(); syncSpin(); figures(); syncNav(); }

  /* ------------------------------------------------------------- wiring */
  FIELDS.forEach(function (k) {
    $("r-" + k).addEventListener("input", function (e) {
      els[k].value = Number(e.target.value).toFixed(1);
      compute();
    });
  });
  ["thick", "shrink"].forEach(function (k) {
    var s = $("r-" + k);
    s.addEventListener("input", function () { els[k].value = Number(s.value).toFixed(1); compute(); });
  });
  Array.prototype.slice.call(root.querySelectorAll("input")).forEach(function (el) {
    if (el.type === "range") return;
    el.addEventListener("input", compute);
    el.addEventListener("change", compute);
  });
  FIELDS.forEach(function (k) {
    els[k].addEventListener("change", function () { commit(k); });
    els[k].addEventListener("blur", function () { commit(k); });
  });
  // 80 and 80.0 are the same number but not the same to read, and a column of
  // figures that sometimes has a decimal and sometimes does not looks wrong
  Array.prototype.slice.call(root.querySelectorAll('input[type="number"]')).forEach(function (el) {
    var tidy = function () {
      var n = parseFloat(el.value);
      if (!isFinite(n)) return;
      var lo = parseFloat(el.min), hi = parseFloat(el.max);
      if (isFinite(lo)) n = Math.max(lo, n);
      if (isFinite(hi)) n = Math.min(hi, n);
      if (n !== parseFloat(el.value)) { el.value = n.toFixed(1); compute(); return; }
      el.value = n.toFixed(1);
    };
    el.addEventListener("change", tidy);
    el.addEventListener("blur", tidy);
  });
  function nudgeAllow(dir) {
    var el = els.allow;
    var step = parseFloat(el.step) || 0.5;
    var lo = parseFloat(el.min), hi = parseFloat(el.max);
    var n = Math.round(((parseFloat(el.value) || 0) + dir * step) / step) * step;
    if (isFinite(lo)) n = Math.max(lo, n);
    if (isFinite(hi)) n = Math.min(hi, n);
    el.value = n.toFixed(1);
    compute();
  }
  $("allow-up").addEventListener("click", function () { nudgeAllow(1); });
  $("allow-down").addEventListener("click", function () { nudgeAllow(-1); });
  function syncSpin() {
    var v = parseFloat(els.allow.value) || 0;
    var lo = parseFloat(els.allow.min), hi = parseFloat(els.allow.max);
    $("allow-down").disabled = isFinite(lo) && v <= lo + 1e-9;
    $("allow-up").disabled = isFinite(hi) && v >= hi - 1e-9;
  }

  $("seam-butt").addEventListener("click", function () { seamMode = "butt"; compute(); scheduleRefit(); });
  $("seam-scarf").addEventListener("click", function () { seamMode = "scarf"; compute(); scheduleRefit(); });
  $("base-outer").addEventListener("click", function () { baseMode = "outer"; compute(); scheduleRefit(); });
  $("base-inner").addEventListener("click", function () { baseMode = "inner"; compute(); scheduleRefit(); });

  // Changing a setup option is the one thing that can put a working design
  // out of range, so each of them asks for a refit afterwards. The dimension
  // fields do not: they are clamped already, and a half-typed number on its
  // way to a bigger one must not drag the pot about.
  ["thick", "shrink", "allow"].forEach(function (k) {
    els[k].addEventListener("input", scheduleRefit);
    els[k].addEventListener("change", scheduleRefit);
    var slide = $("r-" + k);
    if (slide) slide.addEventListener("input", scheduleRefit);
  });
  ["fired", "hmode", "bevel"].forEach(function (group) {
    Array.prototype.slice.call(root.querySelectorAll('input[name="' + uid + "-" + group + '"]'))
      .forEach(function (el) { el.addEventListener("change", scheduleRefit); });
  });
  $("allow-up").addEventListener("click", scheduleRefit);
  $("allow-down").addEventListener("click", scheduleRefit);

  /* -------------------------------------------------------- step navigation */
  var step = 1, LAST = TEXT.steps.length, HEIGHT_STEP = 5;

  // With the base dropped inside, the wall is the whole pot and there is no
  // edge to pare, so the height step has nothing to ask. It is dropped from
  // the run rather than shown empty, and the bar loses a segment with it.
  function liveSteps() {
    var a = [];
    for (var i = 1; i <= LAST; i++) {
      if (i !== HEIGHT_STEP || baseMode === "outer") a.push(i);
    }
    return a;
  }

  var barKey = "";
  function drawBar() {
    var live = liveSteps(), key = live.join(",");
    if (key !== barKey) {
      barKey = key;
      $("steps").innerHTML = live.map(function (n, i) {
        return '<button type="button" class="swv-stepbtn" data-step="' + n + '" form="cmnd-swv-detached" ' +
               'title="' + esc(TEXT.steps[n - 1]) + '" aria-label="Step ' + (i + 1) + ' of ' + live.length +
               ', ' + esc(TEXT.steps[n - 1]) + '"><span></span></button>';
      }).join("");
    }
    Array.prototype.slice.call(root.querySelectorAll(".swv-stepbtn")).forEach(function (b) {
      var n = Number(b.dataset.step);
      b.classList.toggle("on", n === step);
      b.classList.toggle("done", n < step);
      if (n === step) b.setAttribute("aria-current", "step");
      else b.removeAttribute("aria-current");
    });
  }

  function keepInView() {
    var r = root.getBoundingClientRect();
    if (r.top < 0) window.scrollTo({ top: window.pageYOffset + r.top - 16, behavior: "smooth" });
  }

  function showStep(n, dir) {
    var live = liveSteps();
    if (live.indexOf(n) === -1) {
      var d = dir || (n > step ? 1 : -1), m = n;
      while (m >= 1 && m <= LAST && live.indexOf(m) === -1) m += d;
      n = live.indexOf(m) === -1 ? live[d > 0 ? live.length - 1 : 0] : m;
    }
    step = n;
    for (var i = 1; i <= LAST; i++) root.querySelector('[data-step-panel="' + i + '"]').hidden = i !== step;
    syncNav();
    keepInView();
  }

  function syncNav() {
    var live = liveSteps(), at = live.indexOf(step), last = live.length - 1;
    $("nav-back").disabled = at <= 0;
    $("nav-back").textContent = at <= 0 ? TEXT.back : TEXT.backTo + TEXT.steps[live[at - 1] - 1];
    $("nav-next").hidden = at >= last;
    $("nav-next").textContent = at >= last ? "" : TEXT.next + TEXT.steps[live[at + 1] - 1];
    drawBar();
  }

  $("steps").addEventListener("click", function (e) {
    var b = e.target && e.target.closest ? e.target.closest(".swv-stepbtn") : null;
    if (b) showStep(Number(b.dataset.step));
  });
  $("nav-back").addEventListener("click", function () {
    var live = liveSteps(), at = live.indexOf(step);
    if (at > 0) showStep(live[at - 1], -1);
  });
  $("nav-next").addEventListener("click", function () {
    var live = liveSteps(), at = live.indexOf(step);
    if (at < live.length - 1) showStep(live[at + 1], 1);
  });

  /* ------------------------------------------------------------ register */
  LIVE.push({
    form: function () { return findForm(root); },
    props: function () { return lastProps; },
    blocked: function () { return cfg.blockAdd && !lastProps._wall_svg; },
    notify: function () {
      showStep(LAST);
      var s = $("status2");
      if (s.hidden) { s.hidden = false; s.textContent = TEXT.notReady + "."; }
      if (root.scrollIntoView) root.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  });

  showStep(1);
  compute();
}

function esc(s) {
  return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

/* ================================================================== init */
function init(scope) {
  injectCss();
  var nodes = (scope || document).querySelectorAll("[data-cmnd-swv-cutter]");
  Array.prototype.slice.call(nodes).forEach(function (n) {
    try { mount(n); }
    catch (err) {
      if (window.console) console.error("[single wall vessel slab cutter designer]", err);
      n.textContent = "The designer could not start. Please contact us and we will size your set by hand.";
    }
  });
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); });
else init();

document.addEventListener("shopify:section:load", function (e) { init(e.target); });
document.addEventListener("shopify:block:select", function (e) { init(e.target); });

window.CeramindSWVCutter = { init: init, version: VERSION };

})();
